import { jsx as i, jsxs as d, Fragment as ii } from "react/jsx-runtime";
import { forwardRef as j, createElement as se, useContext as gi, createContext as Mi, useId as O, useRef as vi, useCallback as Hi, useLayoutEffect as Pi, useState as H, cloneElement as ce, useEffect as de, useSyncExternalStore as he } from "react";
import { Button as ei } from "@base-ui/react/button";
import { Avatar as Ni } from "@base-ui/react/avatar";
import { Progress as Ci } from "@base-ui/react/progress";
import { Separator as me } from "@base-ui/react/separator";
import { Accordion as ni } from "@base-ui/react/accordion";
import { Input as Bi } from "@base-ui/react/input";
import { Checkbox as $i } from "@base-ui/react/checkbox";
import { Switch as xi } from "@base-ui/react/switch";
import { RadioGroup as pe } from "@base-ui/react/radio-group";
import { Radio as Si } from "@base-ui/react/radio";
import { Select as k } from "@base-ui/react/select";
import { ToggleGroup as be } from "@base-ui/react/toggle-group";
import { Toggle as fe } from "@base-ui/react/toggle";
import { Slider as oi } from "@base-ui/react/slider";
import { Dialog as Q } from "@base-ui/react/dialog";
import { AlertDialog as xe } from "@base-ui/react/alert-dialog";
import { Popover as B } from "@base-ui/react/popover";
import { Tooltip as Z } from "@base-ui/react/tooltip";
import { parseDate as W, parseTime as zi, endOfMonth as ge, startOfMonth as ve } from "@internationalized/date";
import { Calendar as Di, DatePicker as ye, Group as we, DateInput as ji, DateSegment as Oi, Button as li, Label as Ri, Popover as Ne, Dialog as Ce, CalendarContext as ze, TimeField as ke, CalendarStateContext as Me, Heading as Ie, CalendarMonthPicker as Pe, CalendarYearPicker as $e, CalendarGrid as Se, CalendarGridHeader as Te, CalendarHeaderCell as Ae, CalendarGridBody as Le, CalendarCell as Ve, Text as He } from "react-aria-components";
import { Combobox as L } from "@base-ui/react/combobox";
import { Drawer as F } from "@base-ui/react/drawer";
import { Menu as q } from "@base-ui/react/menu";
import { Tabs as pi } from "@base-ui/react/tabs";
import { Toast as _ } from "@base-ui/react/toast";
import { Autocomplete as bi } from "@base-ui/react/autocomplete";
function h(...e) {
  return e.filter(Boolean).join(" ");
}
const Ei = "ui-block ui-text-sm ui-font-medium ui-text-text", si = "ui-kit ui-z-50 ui-rounded-card ui-border ui-border-solid ui-border-border ui-bg-surface ui-p-2 ui-text-text ui-shadow-panel ui-outline-none";
function x(e, t) {
  const u = j(function({ className: r, ...l }, n) {
    const o = !!(l["aria-label"] || l["aria-labelledby"]);
    return /* @__PURE__ */ i(
      "svg",
      {
        ref: n,
        viewBox: "0 0 24 24",
        width: 20,
        height: 20,
        fill: "currentColor",
        focusable: "false",
        role: o ? "img" : void 0,
        "aria-hidden": o ? void 0 : !0,
        ...l,
        className: h("ui-inline-block ui-shrink-0 ui-align-middle", r),
        children: typeof t == "string" ? /* @__PURE__ */ i("path", { d: t }) : t.map(
          (c, m) => se(c.tag, { ...c.attrs, key: m })
        )
      }
    );
  });
  return u.displayName = `${e}Icon`, u;
}
const It = /* @__PURE__ */ x(
  "AccountCircle",
  "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z"
), Pt = /* @__PURE__ */ x(
  "Add",
  "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
), $t = /* @__PURE__ */ x(
  "AddCircle",
  "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
), St = /* @__PURE__ */ x(
  "Apple",
  "M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
), Be = /* @__PURE__ */ x(
  "ArrowBack",
  "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
), Tt = /* @__PURE__ */ x(
  "ArrowForward",
  "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
), At = /* @__PURE__ */ x(
  "ArrowUpward",
  "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
), Lt = /* @__PURE__ */ x(
  "Article",
  "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
), Vt = /* @__PURE__ */ x("BubbleChart", [
  { tag: "circle", attrs: { cx: "7.2", cy: "14.4", r: "3.2" } },
  { tag: "circle", attrs: { cx: "14.8", cy: "18", r: "2" } },
  { tag: "circle", attrs: { cx: "15.2", cy: "8.8", r: "4.8" } }
]), De = /* @__PURE__ */ x(
  "CalendarMonth",
  "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"
), Ht = /* @__PURE__ */ x(
  "ChatBubbleOutlineRounded",
  "M20 4v12H5.17L4 17.17V4h16m0-2H4c-1.1 0-2 .9-2 2v15.59c0 .89 1.08 1.34 1.71.71L6 18h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
), yi = /* @__PURE__ */ x(
  "Check",
  "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
), Fi = /* @__PURE__ */ x(
  "CheckCircleOutline",
  "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
), Ti = /* @__PURE__ */ x(
  "ChevronLeft",
  "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
), Ai = /* @__PURE__ */ x(
  "ChevronRight",
  "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
), Bt = /* @__PURE__ */ x(
  "Circle",
  "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2z"
), Y = /* @__PURE__ */ x(
  "Close",
  "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
), je = /* @__PURE__ */ x(
  "DarkMode",
  "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z"
), Dt = /* @__PURE__ */ x(
  "DeleteOutline",
  "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
), jt = /* @__PURE__ */ x(
  "EditOutlined",
  "m14.06 9.02.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"
), Wi = /* @__PURE__ */ x(
  "ErrorOutline",
  "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
), Ot = /* @__PURE__ */ x(
  "Grade",
  "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
), _i = /* @__PURE__ */ x(
  "InfoOutlined",
  "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
), ci = /* @__PURE__ */ x(
  "KeyboardArrowDown",
  "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
), Rt = /* @__PURE__ */ x(
  "KeyboardArrowUp",
  "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
), Oe = /* @__PURE__ */ x(
  "LightMode",
  "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41l-1.06-1.06zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z"
), Et = /* @__PURE__ */ x(
  "Mic",
  "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
), Ft = /* @__PURE__ */ x(
  "MoreVert",
  "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
), Wt = /* @__PURE__ */ x(
  "Palette",
  "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10c1.38 0 2.5-1.12 2.5-2.5 0-.61-.23-1.2-.64-1.67-.08-.1-.13-.21-.13-.33 0-.28.22-.5.5-.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9zm5.5 11c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm-3-4c-.83 0-1.5-.67-1.5-1.5S13.67 6 14.5 6s1.5.67 1.5 1.5S15.33 9 14.5 9zM5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S7.33 13 6.5 13 5 12.33 5 11.5zm6-4c0 .83-.67 1.5-1.5 1.5S8 8.33 8 7.5 8.67 6 9.5 6s1.5.67 1.5 1.5z"
), _t = /* @__PURE__ */ x(
  "Pause",
  "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
), Gt = /* @__PURE__ */ x(
  "PersonOutline",
  "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
), Ut = /* @__PURE__ */ x(
  "PictureAsPdf",
  "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
), qt = /* @__PURE__ */ x(
  "PlayArrow",
  "M8 5v14l11-7z"
), Kt = /* @__PURE__ */ x(
  "Remove",
  "M19 13H5v-2h14v2z"
), Yt = /* @__PURE__ */ x(
  "RemoveCircle",
  "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
), Qt = /* @__PURE__ */ x(
  "Report",
  "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"
), Jt = /* @__PURE__ */ x(
  "Rotate90DegreesCw",
  "M4.64 19.37c3.03 3.03 7.67 3.44 11.15 1.25l-1.46-1.46c-2.66 1.43-6.04 1.03-8.28-1.21-2.73-2.73-2.73-7.17 0-9.9C7.42 6.69 9.21 6.03 11 6.03V9l4-4-4-4v3.01c-2.3 0-4.61.87-6.36 2.63-3.52 3.51-3.52 9.21 0 12.73zM11 13l6 6 6-6-6-6-6 6z"
), ki = /* @__PURE__ */ x(
  "Search",
  "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
), Xt = /* @__PURE__ */ x(
  "Settings",
  "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
), Zt = /* @__PURE__ */ x(
  "ShareOutlined",
  "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
), iu = /* @__PURE__ */ x(
  "Tune",
  "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
), eu = /* @__PURE__ */ x(
  "Visibility",
  "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
), tu = /* @__PURE__ */ x(
  "VisibilityOff",
  "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
), uu = /* @__PURE__ */ x(
  "Warning",
  "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
), Gi = /* @__PURE__ */ x(
  "WarningAmberOutlined",
  "M12 5.99 19.53 19H4.47L12 5.99M12 2 1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
), Ui = Mi("light");
function au({
  theme: e,
  children: t,
  className: u = "",
  ...a
}) {
  return /* @__PURE__ */ i(Ui.Provider, { value: e, children: /* @__PURE__ */ i(
    "div",
    {
      ...a,
      "data-ui-theme": e,
      className: `ui-kit ui-isolate ${u}`,
      children: t
    }
  ) });
}
function D() {
  return gi(Ui);
}
function wi({
  label: e,
  size: t = 40,
  color: u = "primary"
}) {
  return /* @__PURE__ */ i(
    "svg",
    {
      role: "progressbar",
      "aria-label": e,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      width: t,
      height: t,
      viewBox: "0 0 40 40",
      className: h(
        "ui-shrink-0 -ui-rotate-90 motion-safe:ui-animate-progress-rotate",
        u === "primary" && "ui-text-primary"
      ),
      children: /* @__PURE__ */ i("g", { className: "ui-origin-center motion-safe:ui-animate-progress-step", children: /* @__PURE__ */ i(
        "circle",
        {
          cx: "20",
          cy: "20",
          r: "18",
          pathLength: "360",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "4",
          strokeDasharray: "90 270",
          strokeLinecap: "round",
          className: "motion-safe:ui-animate-progress-arc"
        }
      ) })
    }
  );
}
const Re = "ui-inline-flex ui-items-center ui-justify-center ui-gap-2 ui-rounded-full ui-border ui-border-solid ui-font-medium ui-transition-colors disabled:ui-cursor-not-allowed disabled:ui-opacity-50", Ee = {
  solid: "ui-border-transparent ui-bg-primary ui-text-on-primary hover:ui-bg-primary-hover",
  outline: "ui-border-border ui-bg-transparent ui-text-text hover:ui-bg-muted",
  ghost: "ui-border-transparent ui-bg-transparent ui-text-text hover:ui-bg-muted",
  danger: "ui-border-danger ui-bg-danger ui-text-surface hover:ui-opacity-90"
}, Fe = {
  sm: "ui-min-h-8 ui-px-3 ui-py-1 ui-text-xs",
  md: "ui-min-h-10 ui-px-5 ui-py-2 ui-text-sm",
  lg: "ui-min-h-12 ui-px-6 ui-py-3 ui-text-base"
}, K = j(
  function({
    variant: t = "solid",
    size: u = "md",
    loading: a,
    startIcon: r,
    endIcon: l,
    disabled: n,
    className: o,
    children: c,
    type: m = "button",
    ...p
  }, s) {
    return /* @__PURE__ */ d(
      ei,
      {
        ...p,
        ref: s,
        "data-size": u,
        type: m,
        disabled: n || a,
        "aria-busy": a ? !0 : p["aria-busy"],
        className: h(Re, Ee[t], Fe[u], o),
        children: [
          a && /* @__PURE__ */ i(wi, { label: "Loading", size: 16, color: "inherit" }),
          r,
          c,
          l
        ]
      }
    );
  }
), ru = j(
  function({ className: t, type: u = "button", ...a }, r) {
    return /* @__PURE__ */ i(
      ei,
      {
        ...a,
        ref: r,
        type: u,
        className: h(
          "ui-inline-flex ui-h-10 !ui-min-h-10 ui-items-center ui-justify-center ui-whitespace-nowrap ui-rounded ui-border-0 ui-bg-button-alt ui-px-4 ui-py-2 !ui-text-sm !ui-font-medium !ui-leading-5 ui-text-on-button-alt ui-ring-offset-canvas ui-transition-colors hover:ui-bg-button-alt/90 focus-visible:!ui-outline-none focus-visible:ui-ring-2 focus-visible:ui-ring-button-alt-ring focus-visible:ui-ring-offset-2 disabled:ui-pointer-events-none disabled:ui-opacity-50",
          t
        )
      }
    );
  }
), We = {
  h1: "ui-text-4xl ui-font-semibold ui-leading-tight ui-tracking-tight",
  h2: "ui-text-2xl ui-font-semibold ui-leading-tight",
  h3: "ui-text-lg ui-font-semibold ui-leading-6",
  h4: "ui-text-base ui-font-medium ui-leading-6",
  h5: "ui-text-2xl ui-font-medium",
  h6: "ui-text-xl ui-font-medium",
  body1: "ui-text-base ui-leading-6",
  body2: "ui-text-sm ui-leading-5",
  subtitle1: "ui-text-base ui-font-medium",
  subtitle2: "ui-text-sm ui-font-medium",
  caption: "ui-text-xs ui-leading-4",
  overline: "ui-text-xs ui-uppercase ui-tracking-wider"
};
function nu({
  as: e,
  variant: t = "body1",
  className: u,
  ...a
}) {
  const r = e || (/^h[1-6]$/.test(t) ? t : "p");
  return /* @__PURE__ */ i(r, { ...a, className: h("ui-m-0", We[t], u) });
}
const Ii = j(function({ label: t, children: u, ...a }, r) {
  return /* @__PURE__ */ i(
    K,
    {
      ...a,
      ref: r,
      "aria-label": t,
      className: h("ui-h-10 ui-w-10 ui-shrink-0 !ui-px-0", a.className),
      children: u
    }
  );
}), ou = j(
  function({ className: t, ...u }, a) {
    return /* @__PURE__ */ i(
      "div",
      {
        ...u,
        ref: a,
        className: h(
          "ui-rounded-card ui-border ui-border-solid ui-border-border ui-bg-surface ui-p-5",
          t
        )
      }
    );
  }
), qi = {
  primary: "ui-bg-primary-soft ui-text-primary",
  success: "ui-bg-success/10 ui-text-success",
  danger: "ui-bg-danger/10 ui-text-danger",
  warning: "ui-bg-warning/10 ui-text-warning",
  info: "ui-bg-info/10 ui-text-info",
  neutral: "ui-bg-muted ui-text-subtle"
};
function _e({
  tone: e = "neutral",
  className: t,
  ...u
}) {
  return /* @__PURE__ */ i(
    "span",
    {
      ...u,
      className: h(
        "ui-inline-flex ui-items-center ui-gap-1 ui-rounded-full ui-px-2.5 ui-py-1 ui-text-xs ui-font-medium",
        qi[e],
        t
      )
    }
  );
}
function lu({
  children: e,
  onRemove: t,
  onClick: u,
  selected: a,
  disabled: r,
  label: l,
  tone: n = "neutral"
}) {
  return /* @__PURE__ */ d(_e, { tone: a ? "primary" : n, children: [
    u ? /* @__PURE__ */ i(
      ei,
      {
        type: "button",
        disabled: r,
        "aria-pressed": a,
        onClick: u,
        className: "ui-cursor-pointer ui-border-0 ui-bg-transparent ui-p-0 ui-text-inherit disabled:ui-opacity-50",
        children: e ?? l
      }
    ) : e ?? l,
    t && /* @__PURE__ */ i(
      ei,
      {
        type: "button",
        disabled: r,
        "aria-label": `Remove ${l}`,
        onClick: t,
        className: "ui-ml-1 ui-cursor-pointer ui-rounded-full ui-border-0 ui-bg-transparent ui-px-1 ui-text-inherit",
        children: /* @__PURE__ */ i(Y, { width: 14, height: 14 })
      }
    )
  ] });
}
function su({
  name: e,
  src: t,
  size: u = "md",
  className: a,
  style: r
}) {
  const l = h(
    "ui-inline-flex ui-shrink-0 ui-items-center ui-justify-center ui-overflow-hidden ui-rounded-full ui-bg-primary-soft ui-font-semibold ui-text-primary",
    {
      sm: "ui-h-8 ui-w-8 ui-text-xs",
      md: "ui-h-10 ui-w-10 ui-text-sm",
      lg: "ui-h-14 ui-w-14 ui-text-lg"
    }[u],
    a
  );
  return /* @__PURE__ */ d(
    Ni.Root,
    {
      className: l,
      style: r,
      role: "img",
      "aria-label": e,
      children: [
        t && /* @__PURE__ */ i(
          Ni.Image,
          {
            src: t,
            alt: "",
            className: "ui-h-full ui-w-full ui-object-cover"
          }
        ),
        /* @__PURE__ */ i(Ni.Fallback, { children: e.split(" ").map((n) => n[0]).slice(0, 2).join("") })
      ]
    }
  );
}
function cu({
  tone: e = "info",
  title: t,
  children: u,
  className: a,
  action: r,
  onDismiss: l
}) {
  const n = e === "success" ? Fi : e === "danger" ? Wi : e === "warning" ? Gi : _i;
  return /* @__PURE__ */ d(
    "div",
    {
      role: e === "danger" ? "alert" : "status",
      className: h(
        "ui-flex ui-items-start ui-gap-3 ui-rounded-control ui-p-4 ui-text-sm",
        qi[e],
        a
      ),
      children: [
        /* @__PURE__ */ i(n, {}),
        /* @__PURE__ */ d("div", { className: "ui-min-w-0 ui-flex-1", children: [
          t && /* @__PURE__ */ i("div", { className: "ui-mb-1 ui-font-semibold", children: t }),
          u
        ] }),
        r,
        l && /* @__PURE__ */ i(
          ei,
          {
            type: "button",
            "aria-label": "Dismiss alert",
            onClick: l,
            className: "ui-cursor-pointer ui-border-0 ui-bg-transparent ui-text-inherit",
            children: /* @__PURE__ */ i(Y, { width: 18, height: 18 })
          }
        )
      ]
    }
  );
}
function du({
  value: e,
  label: t,
  inverted: u = !1,
  className: a,
  style: r
}) {
  return /* @__PURE__ */ i(
    Ci.Root,
    {
      className: a,
      style: r,
      "aria-label": t,
      value: e === void 0 ? null : Math.max(0, Math.min(100, e)),
      children: /* @__PURE__ */ i(
        Ci.Track,
        {
          className: h(
            "ui-h-1.5 ui-w-full ui-overflow-hidden ui-rounded-full",
            u ? "ui-bg-white/20" : "ui-bg-muted"
          ),
          children: /* @__PURE__ */ i(
            Ci.Indicator,
            {
              className: h(
                "ui-h-full ui-rounded-full",
                u ? "ui-bg-white" : "ui-bg-primary",
                e === void 0 && "ui-w-1/3 motion-safe:ui-animate-pulse"
              )
            }
          )
        }
      )
    }
  );
}
function hu({
  className: e,
  children: t,
  ...u
}) {
  return /* @__PURE__ */ i(
    me,
    {
      ...u,
      className: `ui-my-4 ui-border-0 ${t ? "ui-flex ui-items-center ui-gap-3 ui-text-sm ui-text-subtle" : "ui-border-t ui-border-solid ui-border-border"} ${e ?? ""}`,
      children: t ? /* @__PURE__ */ d(ii, { children: [
        /* @__PURE__ */ i(
          "span",
          {
            "aria-hidden": "true",
            className: "ui-h-px ui-min-w-0 ui-flex-1 ui-bg-border"
          }
        ),
        /* @__PURE__ */ i("span", { className: "ui-shrink-0", children: t }),
        /* @__PURE__ */ i(
          "span",
          {
            "aria-hidden": "true",
            className: "ui-h-px ui-min-w-0 ui-flex-1 ui-bg-border"
          }
        )
      ] }) : null
    }
  );
}
function mu({
  title: e,
  children: t,
  defaultOpen: u = !1,
  open: a,
  onOpenChange: r,
  className: l,
  contentClassName: n,
  actions: o,
  leading: c,
  subtitle: m,
  style: p,
  headerStyle: s
}) {
  return /* @__PURE__ */ i(
    ni.Root,
    {
      defaultValue: u ? ["item"] : [],
      value: a === void 0 ? void 0 : a ? ["item"] : [],
      onValueChange: (b) => r == null ? void 0 : r(b.length > 0),
      className: l,
      style: p,
      children: /* @__PURE__ */ d(
        ni.Item,
        {
          value: "item",
          className: "ui-relative ui-w-full ui-rounded-control ui-border ui-border-solid ui-border-border ui-bg-surface",
          children: [
            /* @__PURE__ */ d(
              ni.Header,
              {
                className: "ui-m-0 ui-flex ui-items-center ui-text-base",
                style: s,
                children: [
                  /* @__PURE__ */ d(ni.Trigger, { className: "ui-group ui-flex ui-min-w-0 ui-flex-1 ui-cursor-pointer ui-items-center ui-justify-between ui-gap-3 ui-border-0 ui-bg-transparent ui-p-4 ui-text-left ui-font-medium ui-text-text", children: [
                    c,
                    /* @__PURE__ */ d("span", { className: "ui-min-w-0 ui-flex-1", children: [
                      e,
                      m && /* @__PURE__ */ i("span", { className: "ui-block ui-text-xs ui-text-subtle", children: m })
                    ] }),
                    /* @__PURE__ */ i(ci, { className: "motion-safe:ui-transition-transform group-data-[panel-open]:ui-rotate-180" })
                  ] }),
                  o && /* @__PURE__ */ i("div", { className: "ui-flex ui-shrink-0 ui-items-center ui-gap-2 ui-pe-3", children: o })
                ]
              }
            ),
            /* @__PURE__ */ i(
              ni.Panel,
              {
                className: h(
                  "ui-px-4 ui-pb-4 ui-text-sm ui-text-subtle",
                  n
                ),
                children: t
              }
            )
          ]
        }
      )
    }
  );
}
function Ki({
  id: e,
  description: t,
  error: u
}) {
  return t || u ? /* @__PURE__ */ i(
    "span",
    {
      id: e,
      className: h(
        "ui-block ui-text-xs",
        u ? "ui-text-danger" : "ui-text-subtle"
      ),
      children: u || t
    }
  ) : null;
}
const di = "ui-peer ui-w-full ui-rounded-[inherit] ui-border-0 ui-bg-transparent ui-px-4 ui-py-4 !ui-text-base !ui-leading-6 ui-text-text ui-outline-none focus-visible:!ui-outline-none disabled:ui-cursor-not-allowed disabled:ui-text-text/[0.38]", Yi = `${di} ui-block ui-caret-primary placeholder:ui-text-transparent focus:placeholder:ui-text-subtle`;
function ti({
  id: e,
  label: t,
  description: u,
  error: a,
  className: r,
  children: l,
  required: n,
  disabled: o,
  alwaysFloat: c = !1,
  multiline: m = !1,
  select: p = !1,
  renderLabel: s,
  message: b,
  active: y = !1
}) {
  const N = `${t}${n ? " *" : ""}`, z = {
    className: h(
      "ui-pointer-events-auto ui-absolute ui-left-4 ui-top-0 ui-max-w-[calc(100%-2rem)] -ui-translate-y-1/2 ui-truncate ui-text-xs ui-leading-4 ui-text-subtle peer-focus-within:ui-text-primary motion-safe:ui-transition-[top,font-size,line-height] motion-safe:ui-duration-150",
      !c && !p && "peer-placeholder-shown:ui-text-base peer-placeholder-shown:ui-leading-6 peer-focus:ui-top-0 peer-focus:ui-text-xs peer-focus:ui-leading-4",
      !c && !p && (m ? "peer-placeholder-shown:ui-top-7" : "peer-placeholder-shown:ui-top-1/2"),
      p && "ui-max-w-[calc(100%-4.5rem)] peer-data-[popup-open]:ui-text-primary peer-[[data-placeholder]:not(:focus-within):not([data-popup-open])]:ui-top-1/2 peer-[[data-placeholder]:not(:focus-within):not([data-popup-open])]:ui-text-base peer-[[data-placeholder]:not(:focus-within):not([data-popup-open])]:ui-leading-6",
      y && "ui-text-primary",
      a && "!ui-text-danger",
      o && "!ui-text-text/[0.38]"
    ),
    children: N
  };
  return /* @__PURE__ */ d("div", { className: h("ui-grid ui-content-start ui-gap-2 ui-pt-2", r), children: [
    /* @__PURE__ */ d("div", { className: "ui-group ui-relative ui-rounded-control ui-bg-surface", children: [
      l,
      s ? s(z) : /* @__PURE__ */ i("label", { id: `${e}-label`, htmlFor: e, ...z }),
      /* @__PURE__ */ i(
        "fieldset",
        {
          "aria-hidden": "true",
          className: h(
            "ui-pointer-events-none ui-absolute ui-inset-x-0 -ui-top-2 ui-bottom-0 ui-m-0 ui-min-w-0 ui-rounded-[inherit] ui-border ui-border-solid ui-border-border ui-px-3 ui-py-0 [--uik-notch:100%] group-hover:ui-border-subtle peer-focus-within:ui-border-2 peer-focus-within:ui-border-primary",
            !c && !p && "peer-placeholder-shown:[--uik-notch:0px] peer-focus:[--uik-notch:100%]",
            p && "peer-data-[popup-open]:ui-border-2 peer-data-[popup-open]:ui-border-primary peer-[[data-placeholder]:not(:focus-within):not([data-popup-open])]:[--uik-notch:0px]",
            y && "ui-border-2 ui-border-primary",
            a && "!ui-border-danger",
            o && "!ui-border-text/[0.12]"
          ),
          children: /* @__PURE__ */ i("legend", { className: "ui-invisible ui-h-4 ui-w-auto ui-max-w-[--uik-notch] ui-overflow-hidden ui-whitespace-nowrap ui-p-0 ui-text-xs ui-leading-4 motion-safe:ui-transition-[max-width] motion-safe:ui-duration-150", children: /* @__PURE__ */ i("span", { className: "ui-inline-block ui-px-1", children: N }) })
        }
      )
    ] }),
    b ?? /* @__PURE__ */ i(
      Ki,
      {
        id: `${e}-help`,
        description: u,
        error: a
      }
    )
  ] });
}
const pu = j(function({
  label: t,
  description: u,
  error: a,
  className: r,
  id: l,
  startAdornment: n,
  endAdornment: o,
  ...c
}, m) {
  const p = O(), s = l || p;
  return /* @__PURE__ */ d(
    ti,
    {
      id: s,
      label: t,
      description: u,
      error: a,
      className: r,
      required: c.required,
      disabled: c.disabled,
      alwaysFloat: !!(n || o) || ![
        "text",
        "email",
        "number",
        "password",
        "search",
        "tel",
        "url"
      ].includes(c.type ?? "text"),
      children: [
        /* @__PURE__ */ i(
          Bi,
          {
            ...c,
            ref: m,
            id: s,
            placeholder: c.placeholder ?? " ",
            "aria-invalid": !!a || void 0,
            "aria-describedby": u || a ? `${s}-help` : c["aria-describedby"],
            className: `${Yi} ui-h-14 ${n ? "!ui-pl-12" : ""} ${o ? "!ui-pr-14" : ""}`
          }
        ),
        n && /* @__PURE__ */ i("div", { className: "ui-absolute ui-left-4 ui-top-1/2 -ui-translate-y-1/2 ui-text-subtle", children: n }),
        o && /* @__PURE__ */ i("div", { className: "ui-absolute ui-right-2 ui-top-1/2 -ui-translate-y-1/2 ui-text-subtle", children: o })
      ]
    }
  );
}), bu = j(function({
  label: t,
  description: u,
  error: a,
  className: r,
  id: l,
  autoGrow: n = !1,
  minRows: o = 3,
  maxRows: c = 8,
  variant: m = "outlined",
  ...p
}, s) {
  const b = O(), y = l || b, N = vi(null), z = Hi(() => {
    const v = N.current;
    if (v && n) {
      const g = getComputedStyle(v), w = parseFloat(g.lineHeight) || 21, M = parseFloat(g.paddingTop) + parseFloat(g.paddingBottom) + parseFloat(g.borderTopWidth) + parseFloat(g.borderBottomWidth);
      v.style.height = "auto", v.style.height = `${Math.max(o * w + M, Math.min(v.scrollHeight, c * w + M))}px`, v.style.overflowY = v.scrollHeight > c * w + M ? "auto" : "hidden";
    }
  }, [n, o, c]);
  Pi(z, [p.value, z]), Pi(() => {
    var C;
    const v = N.current;
    if (!v || !n)
      return;
    let g = v.clientWidth;
    const w = new ResizeObserver(() => {
      v.clientWidth !== g && (g = v.clientWidth, z());
    });
    w.observe(v);
    let M = !0;
    return (C = document.fonts) == null || C.ready.then(() => {
      M && z();
    }), () => {
      M = !1, w.disconnect();
    };
  }, [n, z]);
  const P = /* @__PURE__ */ i(
    "textarea",
    {
      ...p,
      ref: (v) => {
        N.current = v, typeof s == "function" ? s(v) : s && (s.current = v);
      },
      id: y,
      "aria-label": p["aria-label"] ?? (m === "unstyled" ? t : void 0),
      rows: o,
      placeholder: p.placeholder ?? " ",
      "aria-invalid": !!a || void 0,
      "aria-describedby": u || a ? `${y}-help` : p["aria-describedby"],
      onInput: (v) => {
        var g;
        z(), (g = p.onInput) == null || g.call(p, v);
      },
      className: h(
        m === "unstyled" ? "ui-block ui-w-full ui-min-w-0 ui-border-0 ui-bg-transparent ui-p-0 ui-font-[inherit] ui-text-[inherit] ui-leading-[inherit] ui-outline-none focus-visible:ui-outline-none disabled:ui-cursor-not-allowed disabled:ui-opacity-50" : Yi,
        n ? "ui-resize-none" : "ui-resize-y"
      )
    }
  );
  return m === "unstyled" ? /* @__PURE__ */ d("div", { className: h("ui-grid ui-min-w-0 ui-gap-2", r), children: [
    P,
    /* @__PURE__ */ i(
      Ki,
      {
        id: `${y}-help`,
        description: u,
        error: a
      }
    )
  ] }) : /* @__PURE__ */ i(
    ti,
    {
      id: y,
      label: t,
      description: u,
      error: a,
      className: r,
      required: p.required,
      disabled: p.disabled,
      multiline: !0,
      children: P
    }
  );
});
function Qi(e) {
  if (!(e.target instanceof HTMLInputElement))
    throw new Error("Expected a native input change event");
  return {
    nativeEvent: e,
    target: e.target,
    currentTarget: e.target,
    type: "change",
    bubbles: e.bubbles,
    cancelable: e.cancelable,
    defaultPrevented: e.defaultPrevented,
    eventPhase: e.eventPhase,
    isTrusted: e.isTrusted,
    timeStamp: e.timeStamp,
    preventDefault: () => e.preventDefault(),
    stopPropagation: () => e.stopPropagation(),
    isDefaultPrevented: () => e.defaultPrevented,
    isPropagationStopped: () => e.cancelBubble,
    persist: () => {
    }
  };
}
const fu = j(
  function({ label: t, className: u, onChange: a, ...r }, l) {
    return /* @__PURE__ */ d(
      "label",
      {
        className: h(
          "ui-inline-flex ui-cursor-pointer ui-items-center ui-gap-2 ui-text-sm has-[[data-disabled]]:ui-cursor-not-allowed has-[[data-disabled]]:ui-opacity-50",
          u
        ),
        children: [
          /* @__PURE__ */ i(
            $i.Root,
            {
              ...r,
              inputRef: l,
              onCheckedChange: (n, o) => a == null ? void 0 : a(Qi(o.event)),
              className: "ui-inline-flex ui-h-4 ui-w-4 ui-shrink-0 ui-items-center ui-justify-center ui-rounded ui-border ui-border-solid ui-border-subtle ui-bg-surface data-[checked]:ui-border-primary data-[checked]:ui-bg-primary data-[indeterminate]:ui-border-primary data-[indeterminate]:ui-bg-primary ui-text-on-primary",
              children: /* @__PURE__ */ i($i.Indicator, { children: r.indeterminate ? /* @__PURE__ */ i("span", { className: "ui-block ui-h-0.5 ui-w-2 ui-bg-current" }) : /* @__PURE__ */ i(yi, { width: 14, height: 14 }) })
            }
          ),
          /* @__PURE__ */ i("span", { className: "ui-min-w-0", children: t })
        ]
      }
    );
  }
);
function xu({ label: e, className: t, onChange: u, ...a }) {
  return /* @__PURE__ */ d(
    "label",
    {
      className: h(
        "ui-inline-flex ui-cursor-pointer ui-items-center ui-gap-3 ui-text-sm has-[[data-disabled]]:ui-cursor-not-allowed has-[[data-disabled]]:ui-opacity-50",
        t
      ),
      children: [
        /* @__PURE__ */ i(
          xi.Root,
          {
            ...a,
            onCheckedChange: (r, l) => u == null ? void 0 : u(Qi(l.event)),
            className: "ui-group ui-relative ui-inline-flex ui-h-6 ui-w-11 ui-shrink-0 ui-items-center ui-rounded-full ui-bg-subtle/40 ui-transition-colors data-[checked]:ui-bg-primary",
            children: /* @__PURE__ */ i(xi.Thumb, { className: "ui-ml-1 ui-h-4 ui-w-4 ui-rounded-full ui-bg-white ui-transition-transform data-[checked]:ui-translate-x-5" })
          }
        ),
        e
      ]
    }
  );
}
function gu({
  label: e,
  options: t,
  value: u,
  onChange: a,
  name: r,
  disabled: l
}) {
  const n = O();
  return /* @__PURE__ */ d(
    pe,
    {
      value: u,
      onValueChange: a,
      name: r,
      disabled: l,
      "aria-labelledby": n,
      className: "ui-grid ui-gap-3 data-[disabled]:ui-opacity-50",
      children: [
        /* @__PURE__ */ i("span", { id: n, className: Ei, children: e }),
        t.map((o) => /* @__PURE__ */ d(
          "label",
          {
            className: "ui-flex ui-items-center ui-gap-2 ui-text-sm",
            children: [
              /* @__PURE__ */ i(
                Si.Root,
                {
                  value: o.value,
                  disabled: o.disabled,
                  className: "ui-inline-flex ui-h-4 ui-w-4 ui-items-center ui-justify-center ui-rounded-full ui-border ui-border-solid ui-border-subtle ui-bg-surface data-[checked]:ui-border-primary",
                  children: /* @__PURE__ */ i(Si.Indicator, { className: "ui-h-2 ui-w-2 ui-rounded-full ui-bg-primary" })
                }
              ),
              o.label
            ]
          },
          o.value
        ))
      ]
    }
  );
}
const ui = Mi(null);
function R() {
  return gi(ui);
}
function vu(e) {
  return /* @__PURE__ */ i(
    Ji,
    {
      ...e,
      multiple: !1,
      onChange: (t) => {
        var u;
        return (u = e.onChange) == null ? void 0 : u.call(e, String(t ?? ""));
      }
    }
  );
}
function Ji({
  label: e,
  description: t,
  error: u,
  className: a,
  options: r,
  placeholder: l,
  id: n,
  value: o,
  defaultValue: c,
  onChange: m,
  multiple: p,
  name: s,
  disabled: b,
  required: y
}) {
  const N = O(), z = n || N, P = D(), v = R();
  return /* @__PURE__ */ d(
    k.Root,
    {
      value: o === "" ? null : o,
      defaultValue: c === "" ? null : c,
      multiple: p,
      onValueChange: m,
      items: r,
      name: s,
      disabled: b,
      required: y,
      children: [
        /* @__PURE__ */ i(
          ti,
          {
            id: z,
            label: e,
            description: t,
            error: u,
            className: a,
            disabled: b,
            required: y,
            select: !0,
            children: /* @__PURE__ */ d(
              k.Trigger,
              {
                id: z,
                "aria-invalid": !!u || void 0,
                "aria-describedby": t || u ? `${z}-help` : void 0,
                className: h(
                  di,
                  "ui-group/select ui-flex ui-h-14 ui-min-w-0 ui-items-center ui-justify-between ui-gap-3 ui-text-left"
                ),
                children: [
                  /* @__PURE__ */ i(
                    k.Value,
                    {
                      placeholder: l || "Select an option…",
                      className: "ui-min-w-0 ui-truncate data-[placeholder]:ui-text-transparent group-focus/select:data-[placeholder]:ui-text-subtle group-data-[popup-open]/select:data-[placeholder]:ui-text-subtle"
                    }
                  ),
                  /* @__PURE__ */ i(k.Icon, { className: "ui-flex ui-shrink-0 ui-text-subtle group-disabled/select:ui-text-inherit motion-safe:ui-transition-transform motion-safe:ui-duration-150 group-data-[popup-open]/select:ui-rotate-180", children: /* @__PURE__ */ i(ci, { width: 24, height: 24 }) })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ i(k.Portal, { container: v || void 0, children: /* @__PURE__ */ i(
          k.Positioner,
          {
            sideOffset: 6,
            align: "start",
            alignItemWithTrigger: !1,
            className: "ui-z-50",
            children: /* @__PURE__ */ i(
              k.Popup,
              {
                "data-ui-overlay": "",
                "data-ui-theme": P,
                className: h(
                  si,
                  "ui-w-[--anchor-width] ui-max-w-[calc(100vw-1rem)] ui-overflow-hidden !ui-p-0"
                ),
                children: /* @__PURE__ */ d(k.List, { className: "ui-scrollbar ui-max-h-60 ui-overflow-y-auto ui-p-2 ui-outline-none [scrollbar-gutter:stable]", children: [
                  l && !p && !y && /* @__PURE__ */ i(
                    k.Item,
                    {
                      value: "",
                      className: "ui-cursor-pointer ui-rounded-lg ui-px-3 ui-py-2.5 ui-text-sm ui-text-subtle ui-outline-none data-[highlighted]:ui-bg-muted",
                      children: /* @__PURE__ */ i(k.ItemText, { children: l })
                    }
                  ),
                  r.map((g) => /* @__PURE__ */ d(
                    k.Item,
                    {
                      value: g.value,
                      disabled: g.disabled,
                      className: "ui-flex ui-cursor-pointer ui-items-center ui-justify-between ui-gap-3 ui-rounded-lg ui-px-3 ui-py-2.5 ui-text-sm ui-outline-none data-[highlighted]:ui-bg-muted data-[selected]:ui-bg-primary-soft data-[selected]:ui-text-primary data-[disabled]:ui-opacity-40",
                      children: [
                        /* @__PURE__ */ i(k.ItemText, { children: g.label }),
                        /* @__PURE__ */ i(k.ItemIndicator, { children: /* @__PURE__ */ i(yi, { width: 18, height: 18 }) })
                      ]
                    },
                    g.value
                  ))
                ] })
              }
            )
          }
        ) })
      ]
    }
  );
}
function yu({
  value: e,
  onChange: t,
  ...u
}) {
  return /* @__PURE__ */ i(
    Ji,
    {
      ...u,
      multiple: !0,
      value: e,
      onChange: (a) => t(Array.isArray(a) ? a : [])
    }
  );
}
function wu({
  label: e,
  options: t,
  value: u,
  onChange: a,
  multiple: r = !1,
  disabled: l = !1
}) {
  const n = Array.isArray(u) ? u : [u];
  return /* @__PURE__ */ i(
    be,
    {
      value: n,
      multiple: r,
      disabled: l,
      onValueChange: (o) => {
        r ? a(o) : o[0] && a(o[0]);
      },
      role: "group",
      "aria-label": e,
      "aria-disabled": l || void 0,
      className: "ui-isolate ui-inline-grid ui-auto-cols-fr ui-grid-flow-col ui-max-w-full ui-py-1 ui-align-middle",
      children: t.map((o) => {
        const c = n.includes(o.value);
        return /* @__PURE__ */ i(
          fe,
          {
            type: "button",
            disabled: l || o.disabled,
            "aria-pressed": c,
            value: o.value,
            className: h(
              "ui-relative -ui-ms-px ui-inline-flex ui-h-10 ui-min-w-12 ui-cursor-pointer ui-items-center ui-justify-center ui-rounded-none ui-border ui-border-solid ui-border-subtle ui-px-4 ui-py-0 ui-text-sm !ui-font-medium ui-tracking-[0.1px] first:ui-ms-0 first:ui-rounded-s-full last:ui-rounded-e-full focus-visible:ui-z-10 disabled:ui-cursor-not-allowed disabled:ui-border-text/[0.12] disabled:ui-text-text/[0.38] motion-safe:ui-transition-colors before:ui-pointer-events-none before:ui-absolute before:ui-inset-0 before:ui-rounded-[inherit] before:ui-bg-current before:ui-opacity-0 before:ui-content-[''] enabled:hover:before:ui-opacity-[0.08] enabled:focus-visible:before:ui-opacity-[0.12] enabled:active:before:ui-opacity-[0.12] after:ui-absolute after:ui-inset-x-0 after:-ui-inset-y-1 after:ui-content-['']",
              c ? "ui-bg-primary-soft ui-text-text disabled:ui-bg-text/[0.12]" : "ui-bg-transparent ui-text-text"
            ),
            children: /* @__PURE__ */ i("span", { className: "ui-relative ui-whitespace-nowrap", children: o.label })
          },
          o.value
        );
      })
    }
  );
}
function Nu({
  value: e,
  onChange: t,
  ...u
}) {
  return /* @__PURE__ */ i(
    Xi,
    {
      ...u,
      value: e,
      onChange: (a) => t(Array.isArray(a) ? a[0] : a)
    }
  );
}
function Xi({
  label: e,
  value: t,
  onChange: u,
  min: a = 0,
  max: r = 100,
  step: l = 1,
  disabled: n,
  formatValue: o = String,
  name: c,
  trackThickness: m = 14
}) {
  const p = O(), s = Array.isArray(t) ? t : [t], b = Array.isArray(t), y = (w) => r === a ? 0 : Math.max(0, Math.min(100, (w - a) / (r - a) * 100)), N = b ? y(s[0]) : 0, z = y(s[s.length - 1]), P = Math.max(1, m), v = Math.min(4, P), g = 8;
  return /* @__PURE__ */ d(
    oi.Root,
    {
      value: t,
      onValueChange: u,
      min: a,
      max: r,
      step: l,
      disabled: n,
      name: c,
      thumbCollisionBehavior: "none",
      "aria-labelledby": p,
      className: "ui-grid ui-gap-3",
      children: [
        /* @__PURE__ */ d("div", { className: "ui-flex ui-justify-between ui-gap-3", children: [
          /* @__PURE__ */ i(
            "span",
            {
              id: p,
              className: h(Ei, n && "!ui-text-text/[0.38]"),
              children: e
            }
          ),
          /* @__PURE__ */ i(
            "output",
            {
              className: h(
                "ui-text-sm ui-font-medium",
                n ? "ui-text-text/[0.38]" : "ui-text-primary"
              ),
              children: s.map(o).join(" – ")
            }
          )
        ] }),
        /* @__PURE__ */ i(
          oi.Control,
          {
            className: h(
              "ui-relative ui-mx-6 ui-mt-8 ui-flex ui-h-12 ui-items-center ui-touch-none ui-select-none",
              n ? "ui-cursor-not-allowed" : "ui-cursor-pointer"
            ),
            children: /* @__PURE__ */ d(
              oi.Track,
              {
                "data-slot": "slider-track",
                className: "ui-relative ui-w-full",
                style: { height: P },
                children: [
                  b && /* @__PURE__ */ i(
                    "span",
                    {
                      "aria-hidden": "true",
                      "data-slot": "slider-inactive-track",
                      className: h(
                        "ui-absolute ui-inset-y-0 ui-overflow-hidden ui-rounded-s-full ui-rounded-e-[2px]",
                        n ? "ui-bg-text/[0.12]" : "ui-bg-primary-soft"
                      ),
                      style: {
                        insetInlineStart: 0,
                        width: `max(0px, calc(${N}% - ${g}px))`
                      },
                      children: /* @__PURE__ */ i(
                        "span",
                        {
                          className: h(
                            "ui-absolute ui-start-1.5 ui-top-1/2 -ui-translate-y-1/2 ui-rounded-full",
                            n ? "ui-bg-text/[0.38]" : "ui-bg-primary"
                          ),
                          style: { width: v, height: v }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ i(
                    oi.Indicator,
                    {
                      "data-slot": "slider-active-track",
                      className: h(
                        "ui-rounded-e-[2px]",
                        b ? "ui-rounded-s-[2px]" : "ui-rounded-s-full",
                        n ? "ui-bg-text/[0.38]" : "ui-bg-primary"
                      ),
                      style: {
                        position: "absolute",
                        insetInlineStart: b ? `calc(${N}% + ${g}px)` : 0,
                        width: `max(0px, calc(${z - N}% - ${b ? g * 2 : g}px))`
                      }
                    }
                  ),
                  /* @__PURE__ */ i(
                    "span",
                    {
                      "aria-hidden": "true",
                      "data-slot": "slider-inactive-track",
                      className: h(
                        "ui-absolute ui-inset-y-0 ui-overflow-hidden ui-rounded-s-[2px] ui-rounded-e-full",
                        n ? "ui-bg-text/[0.12]" : "ui-bg-primary-soft"
                      ),
                      style: {
                        insetInlineStart: `calc(${z}% + ${g}px)`,
                        width: `max(0px, calc(${100 - z}% - ${g}px))`
                      },
                      children: /* @__PURE__ */ i(
                        "span",
                        {
                          className: h(
                            "ui-absolute ui-end-1.5 ui-top-1/2 -ui-translate-y-1/2 ui-rounded-full",
                            n ? "ui-bg-text/[0.38]" : "ui-bg-primary"
                          ),
                          style: { width: v, height: v }
                        }
                      )
                    }
                  ),
                  s.map((w, M) => /* @__PURE__ */ d(
                    oi.Thumb,
                    {
                      index: M,
                      "data-slot": "slider-thumb",
                      "aria-label": b ? `${e} ${M === 0 ? "minimum" : "maximum"}` : e,
                      "aria-valuetext": o(w),
                      className: (C) => h(
                        "ui-group/thumb ui-flex ui-h-12 ui-w-12 ui-items-center ui-justify-center ui-outline-none [&_input]:!ui-outline-none",
                        C.dragging && C.activeThumbIndex === M && "[--uik-slider-handle-width:2px] [--uik-slider-label-opacity:1]"
                      ),
                      children: [
                        /* @__PURE__ */ i(
                          "span",
                          {
                            "aria-hidden": "true",
                            "data-slot": "slider-handle",
                            className: h(
                              "ui-pointer-events-none ui-block ui-h-11 ui-w-[var(--uik-slider-handle-width,4px)] ui-shrink-0 ui-rounded-full motion-safe:ui-transition-[width] motion-safe:ui-duration-100",
                              n ? "ui-bg-text/[0.38]" : "ui-bg-primary group-has-[:focus-visible]/thumb:ui-w-0.5 group-has-[:focus-visible]/thumb:ui-outline group-has-[:focus-visible]/thumb:ui-outline-2 group-has-[:focus-visible]/thumb:ui-outline-offset-4 group-has-[:focus-visible]/thumb:ui-outline-primary"
                            )
                          }
                        ),
                        !n && /* @__PURE__ */ i(
                          "span",
                          {
                            "aria-hidden": "true",
                            "data-slot": "slider-value",
                            className: "ui-pointer-events-none ui-absolute ui-bottom-[calc(100%+10px)] ui-left-1/2 ui-z-20 ui-flex ui-h-8 ui-min-w-8 ui-max-w-40 -ui-translate-x-1/2 ui-items-center ui-justify-center ui-truncate ui-rounded-full ui-bg-text ui-px-3 ui-text-sm ui-font-medium ui-text-surface ui-opacity-[var(--uik-slider-label-opacity,0)] group-hover/thumb:ui-opacity-100 group-has-[:focus-visible]/thumb:ui-opacity-100 motion-safe:ui-transition-opacity motion-safe:ui-duration-100",
                            children: o(w)
                          }
                        )
                      ]
                    },
                    M
                  ))
                ]
              }
            )
          }
        ),
        b && /* @__PURE__ */ d(
          "div",
          {
            className: h(
              "ui-flex ui-justify-between ui-text-xs",
              n ? "ui-text-text/[0.38]" : "ui-text-subtle"
            ),
            children: [
              /* @__PURE__ */ i("span", { children: o(a) }),
              /* @__PURE__ */ i("span", { children: o(r) })
            ]
          }
        )
      ]
    }
  );
}
function Cu({
  value: e,
  onChange: t,
  ...u
}) {
  return /* @__PURE__ */ i(
    Xi,
    {
      ...u,
      value: e,
      onChange: (a) => {
        Array.isArray(a) && t(a);
      }
    }
  );
}
function Ge({
  open: e,
  onOpenChange: t,
  dismissible: u = !0,
  ...a
}) {
  return /* @__PURE__ */ i(
    Q.Root,
    {
      open: e,
      disablePointerDismissal: !u,
      onOpenChange: (r, l) => {
        !r && !u ? l.cancel() : t(r);
      },
      children: /* @__PURE__ */ i(Zi, { ...a, dismissible: u })
    }
  );
}
function Zi({
  title: e,
  description: t,
  children: u,
  footer: a,
  className: r,
  fullScreen: l,
  dismissible: n = !0,
  closeLabel: o = "Close dialog"
}) {
  const c = D(), m = R(), [p, s] = H(null);
  return /* @__PURE__ */ d(Q.Portal, { container: m || void 0, children: [
    /* @__PURE__ */ i(Q.Backdrop, { className: "ui-fixed ui-inset-0 ui-z-50 ui-bg-black/60" }),
    /* @__PURE__ */ i(
      Q.Popup,
      {
        "data-ui-overlay": "",
        "data-fullscreen": l || void 0,
        ref: s,
        "aria-modal": "true",
        "data-ui-theme": c,
        className: h(
          si,
          "ui-fixed ui-left-1/2 ui-top-1/2 ui-max-h-[85dvh] ui-w-[calc(100%-2rem)] ui-max-w-lg -ui-translate-x-1/2 -ui-translate-y-1/2 ui-overflow-y-auto !ui-p-6",
          l && "!ui-inset-0 !ui-h-dvh !ui-max-h-dvh !ui-w-full !ui-max-w-none !ui-translate-x-0 !ui-translate-y-0 !ui-rounded-none",
          r
        ),
        children: /* @__PURE__ */ d(ui.Provider, { value: p, children: [
          /* @__PURE__ */ d("div", { className: "ui-mb-5 ui-flex ui-items-start ui-justify-between ui-gap-4", children: [
            /* @__PURE__ */ d("div", { children: [
              /* @__PURE__ */ i(Q.Title, { className: "ui-m-0 ui-text-xl ui-font-semibold", children: e }),
              t && /* @__PURE__ */ i(Q.Description, { className: "ui-mb-0 ui-mt-2 ui-text-sm ui-text-subtle", children: t })
            ] }),
            n && /* @__PURE__ */ i(
              Q.Close,
              {
                render: /* @__PURE__ */ i(Ii, { label: o, variant: "ghost", children: /* @__PURE__ */ i(Y, {}) })
              }
            )
          ] }),
          u,
          a && /* @__PURE__ */ i("div", { className: "ui-mt-6 ui-flex ui-flex-wrap ui-justify-end ui-gap-2", children: a })
        ] })
      }
    )
  ] });
}
const zu = Ge;
function ku({
  onConfirm: e,
  confirmLabel: t = "Confirm",
  cancelLabel: u = "Cancel",
  destructive: a = !1,
  busy: r,
  children: l,
  ...n
}) {
  const o = !r && n.dismissible !== !1;
  return /* @__PURE__ */ i(
    xe.Root,
    {
      open: n.open,
      onOpenChange: (c, m) => {
        !c && !o ? m.cancel() : n.onOpenChange(c);
      },
      children: /* @__PURE__ */ i(
        Zi,
        {
          ...n,
          dismissible: o,
          footer: /* @__PURE__ */ d(ii, { children: [
            /* @__PURE__ */ i(
              K,
              {
                variant: "outline",
                disabled: r,
                onClick: () => n.onOpenChange(!1),
                children: u
              }
            ),
            /* @__PURE__ */ i(
              K,
              {
                variant: a ? "danger" : "solid",
                loading: r,
                onClick: e,
                children: t
              }
            )
          ] }),
          children: l
        }
      )
    }
  );
}
function Mu({
  label: e,
  children: t,
  trigger: u,
  open: a,
  onOpenChange: r
}) {
  const l = D(), n = R(), [o, c] = H(null);
  return /* @__PURE__ */ d(B.Root, { open: a, onOpenChange: r, children: [
    /* @__PURE__ */ i(B.Trigger, { render: /* @__PURE__ */ i(K, { variant: "outline" }), children: u || e }),
    /* @__PURE__ */ i(B.Portal, { container: n || void 0, children: /* @__PURE__ */ i(
      B.Positioner,
      {
        sideOffset: 8,
        align: "start",
        className: "ui-z-50",
        children: /* @__PURE__ */ i(
          B.Popup,
          {
            "data-ui-overlay": "",
            ref: c,
            "aria-label": e,
            "data-ui-theme": l,
            className: h(
              si,
              "ui-w-72 ui-max-w-[calc(100vw-1rem)] !ui-p-4"
            ),
            children: /* @__PURE__ */ i(ui.Provider, { value: o, children: t })
          }
        )
      }
    ) })
  ] });
}
function Iu({
  content: e,
  children: t
}) {
  const u = O(), [a, r] = H(!1), l = D(), n = R();
  return /* @__PURE__ */ i(Z.Provider, { delay: 0, closeDelay: 150, children: /* @__PURE__ */ d(Z.Root, { open: a, onOpenChange: r, children: [
    /* @__PURE__ */ i(
      Z.Trigger,
      {
        render: ce(t, {
          "aria-describedby": [t.props["aria-describedby"], a && u].filter(Boolean).join(" ") || void 0
        })
      }
    ),
    /* @__PURE__ */ i(Z.Portal, { container: n || void 0, children: /* @__PURE__ */ i(Z.Positioner, { side: "top", sideOffset: 8, className: "ui-z-50", children: /* @__PURE__ */ i(
      Z.Popup,
      {
        "data-ui-overlay": "",
        id: u,
        role: "tooltip",
        "data-ui-theme": l,
        className: h(
          si,
          "ui-max-w-xs !ui-rounded-lg !ui-px-3 !ui-py-2 ui-text-xs"
        ),
        children: e
      }
    ) }) })
  ] }) });
}
const fi = "ui-flex ui-h-10 ui-w-10 ui-shrink-0 ui-cursor-pointer ui-items-center ui-justify-center ui-rounded-full ui-border-0 ui-bg-transparent ui-text-subtle hover:ui-bg-text/[0.08] data-[pressed]:ui-bg-text/[0.12] disabled:ui-cursor-not-allowed disabled:ui-text-text/[0.38]", ie = "ui-rounded-sm ui-px-0.5 ui-tabular-nums ui-outline-none data-[placeholder]:ui-text-subtle data-[disabled]:!ui-text-text/[0.38] focus:ui-bg-primary focus:ui-text-on-primary focus-visible:!ui-outline-none";
function ee({
  error: e,
  description: t
}) {
  return e || t ? /* @__PURE__ */ i(
    He,
    {
      slot: "description",
      className: h("ui-text-xs", e ? "ui-text-danger" : "ui-text-subtle"),
      children: e || t
    }
  ) : null;
}
function Li({
  items: e,
  value: t,
  onChange: u,
  disabled: a,
  calendarBody: r,
  "aria-label": l
}) {
  const n = D(), o = R();
  return /* @__PURE__ */ d(
    k.Root,
    {
      value: Number(t),
      onValueChange: u,
      items: e.map((c) => ({ value: c.id, label: c.formatted })),
      disabled: a,
      children: [
        /* @__PURE__ */ d(
          k.Trigger,
          {
            "aria-label": l,
            className: "ui-flex ui-h-10 ui-min-w-0 ui-items-center ui-gap-1 ui-rounded-full ui-border-0 ui-bg-transparent ui-px-2 !ui-text-sm ui-font-medium ui-text-subtle hover:ui-bg-text/[0.08] data-[popup-open]:ui-bg-text/[0.12] disabled:ui-text-text/[0.38]",
            children: [
              /* @__PURE__ */ i(k.Value, { className: "ui-truncate" }),
              /* @__PURE__ */ i(k.Icon, { children: /* @__PURE__ */ i(ci, { width: 18, height: 18 }) })
            ]
          }
        ),
        /* @__PURE__ */ i(k.Portal, { container: r || o || void 0, children: /* @__PURE__ */ i(
          k.Positioner,
          {
            anchor: r,
            positionMethod: "absolute",
            align: "start",
            alignItemWithTrigger: !1,
            sideOffset: 0,
            className: "!ui-absolute !ui-inset-0 !ui-h-full !ui-w-[calc(100%+var(--uik-calendar-menu-bleed,0px))] !ui-transform-none ui-z-10",
            children: /* @__PURE__ */ i(
              k.Popup,
              {
                "data-ui-overlay": "",
                "data-ui-theme": n,
                "data-slot": "calendar-navigation-menu",
                className: "ui-kit ui-h-full ui-w-full ui-overflow-hidden ui-bg-muted ui-text-text ui-outline-none",
                children: /* @__PURE__ */ i(k.List, { className: "ui-scrollbar ui-h-full ui-overflow-y-auto ui-outline-none", children: e.map((c) => /* @__PURE__ */ d(
                  k.Item,
                  {
                    value: c.id,
                    disabled: c.disabled,
                    className: "ui-flex ui-min-h-12 ui-cursor-pointer ui-items-center ui-gap-3 ui-px-3 ui-text-base ui-outline-none data-[highlighted]:ui-bg-text/[0.08] data-[selected]:ui-bg-primary-soft data-[selected]:ui-text-primary data-[disabled]:ui-cursor-not-allowed data-[disabled]:ui-text-text/[0.38]",
                    children: [
                      /* @__PURE__ */ i("span", { className: "ui-flex ui-h-6 ui-w-6 ui-items-center ui-justify-center", children: /* @__PURE__ */ i(k.ItemIndicator, { children: /* @__PURE__ */ i(yi, { width: 24, height: 24 }) }) }),
                      /* @__PURE__ */ i(k.ItemText, { children: c.formatted })
                    ]
                  },
                  c.id
                )) })
              }
            )
          }
        ) })
      ]
    }
  );
}
function te() {
  const e = gi(Me), [t, u] = H(null);
  return /* @__PURE__ */ d(ii, { children: [
    /* @__PURE__ */ i(Ie, { className: "ui-sr-only" }),
    /* @__PURE__ */ d("header", { className: "ui-grid ui-min-h-12 ui-grid-cols-2", children: [
      /* @__PURE__ */ d("div", { className: "ui-flex ui-items-center ui-justify-between", children: [
        /* @__PURE__ */ i(li, { slot: "previous", className: fi, children: /* @__PURE__ */ i(Ti, { width: 24, height: 24 }) }),
        /* @__PURE__ */ i(Pe, { format: "short", children: (a) => /* @__PURE__ */ i(
          Li,
          {
            ...a,
            calendarBody: t,
            disabled: e.isDisabled,
            items: a.items.map((r) => ({
              ...r,
              disabled: !!(e.minValue && ge(r.date).compare(e.minValue) < 0 || e.maxValue && ve(r.date).compare(e.maxValue) > 0)
            }))
          }
        ) }),
        /* @__PURE__ */ i(li, { slot: "next", className: fi, children: /* @__PURE__ */ i(Ai, { width: 24, height: 24 }) })
      ] }),
      /* @__PURE__ */ d("div", { className: "ui-flex ui-items-center ui-justify-between", children: [
        /* @__PURE__ */ i(
          li,
          {
            slot: null,
            "aria-label": "Previous year",
            onPress: () => e.focusPreviousSection(!0),
            isDisabled: e.isDisabled || !!(e.minValue && e.visibleRange.start.year <= e.minValue.year),
            className: fi,
            children: /* @__PURE__ */ i(Ti, { width: 24, height: 24 })
          }
        ),
        /* @__PURE__ */ i($e, { visibleYears: 201, children: (a) => /* @__PURE__ */ i(
          Li,
          {
            ...a,
            calendarBody: t,
            disabled: e.isDisabled,
            onChange: (r) => {
              const l = a.items.find(
                (n) => n.id === Number(r)
              );
              l && r !== null && e.setFocusedDate(
                e.focusedDate.set({
                  era: l.date.era,
                  year: l.date.year
                })
              );
            }
          }
        ) }),
        /* @__PURE__ */ i(
          li,
          {
            slot: null,
            "aria-label": "Next year",
            onPress: () => e.focusNextSection(!0),
            isDisabled: e.isDisabled || !!(e.maxValue && e.visibleRange.end.year >= e.maxValue.year),
            className: fi,
            children: /* @__PURE__ */ i(Ai, { width: 24, height: 24 })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ i(
      "div",
      {
        ref: u,
        "data-slot": "calendar-body",
        className: "ui-relative ui-pt-4",
        children: /* @__PURE__ */ d(Se, { className: "ui-w-full ui-table-fixed ui-border-separate ui-border-spacing-0", children: [
          /* @__PURE__ */ i(Te, { children: (a) => /* @__PURE__ */ i(Ae, { className: "ui-h-10 ui-p-1 ui-text-center ui-text-base ui-font-normal ui-text-subtle", children: a }) }),
          /* @__PURE__ */ i(Le, { className: "[&_td]:ui-p-1", children: (a) => /* @__PURE__ */ i(
            Ve,
            {
              date: a,
              className: "ui-relative ui-mx-auto ui-flex ui-aspect-square ui-w-full ui-max-w-10 ui-cursor-pointer ui-items-center ui-justify-center ui-rounded-full ui-text-base ui-leading-6 ui-outline-none before:ui-absolute before:-ui-inset-1 before:ui-content-[''] data-[hovered]:ui-bg-text/[0.08] data-[pressed]:ui-bg-text/[0.12] data-[selected]:ui-bg-primary data-[selected]:!ui-text-on-primary data-[today]:ui-text-primary data-[today]:ui-ring-1 data-[today]:ui-ring-inset data-[today]:ui-ring-primary data-[disabled]:ui-cursor-not-allowed data-[disabled]:ui-text-text/[0.38] data-[outside-month]:ui-text-text/[0.38] data-[focus-visible]:ui-outline data-[focus-visible]:ui-outline-2 data-[focus-visible]:ui-outline-offset-2 data-[focus-visible]:ui-outline-primary"
            }
          ) })
        ] })
      }
    )
  ] });
}
function Ue({
  label: e = "Choose a date",
  value: t,
  onChange: u,
  min: a,
  max: r,
  disabled: l,
  readOnly: n,
  className: o
}) {
  return /* @__PURE__ */ i(
    Di,
    {
      "aria-label": e,
      value: t ? W(t) : null,
      onChange: (c) => u(c.toString()),
      minValue: a ? W(a) : void 0,
      maxValue: r ? W(r) : void 0,
      isDisabled: l,
      isReadOnly: n,
      className: h("ui-w-[336px] ui-max-w-full", o),
      children: /* @__PURE__ */ i(te, {})
    }
  );
}
const Pu = Ue;
function $u({
  label: e,
  value: t,
  onChange: u,
  min: a,
  max: r,
  disabled: l,
  readOnly: n,
  required: o,
  description: c,
  error: m,
  className: p,
  name: s
}) {
  const b = O(), y = D(), N = R(), [z, P] = H(null), [v, g] = H(!1), [w, M] = H(t);
  return /* @__PURE__ */ i(
    ye,
    {
      value: t ? W(t) : null,
      onChange: (C) => u((C == null ? void 0 : C.toString()) || null),
      isOpen: v,
      onOpenChange: (C) => {
        C && M(t), g(C);
      },
      minValue: a ? W(a) : void 0,
      maxValue: r ? W(r) : void 0,
      isDisabled: l,
      isReadOnly: n,
      isRequired: o,
      isInvalid: !!m,
      name: s,
      className: p,
      children: ({ isOpen: C }) => /* @__PURE__ */ d(ii, { children: [
        /* @__PURE__ */ i(
          ti,
          {
            id: b,
            label: e,
            required: o,
            disabled: l,
            error: m,
            active: C,
            alwaysFloat: !0,
            renderLabel: (T) => /* @__PURE__ */ i(Ri, { ...T }),
            message: /* @__PURE__ */ i(ee, { error: m, description: c }),
            children: /* @__PURE__ */ d(
              we,
              {
                "data-slot": "date-field-control",
                className: h(
                  di,
                  "ui-flex ui-h-14 ui-min-w-0 ui-items-center ui-justify-between ui-gap-2 !ui-py-0 !ui-pr-2 data-[disabled]:ui-cursor-not-allowed data-[disabled]:ui-text-text/[0.38]"
                ),
                children: [
                  /* @__PURE__ */ i(ji, { className: "ui-flex ui-min-w-0 ui-flex-1 ui-outline-none", children: (T) => /* @__PURE__ */ i(Oi, { segment: T, className: ie }) }),
                  /* @__PURE__ */ i(
                    li,
                    {
                      "aria-label": `Open ${e} calendar`,
                      className: "ui-flex ui-h-10 ui-w-10 ui-shrink-0 ui-cursor-pointer ui-items-center ui-justify-center ui-rounded-full ui-border-0 ui-bg-transparent ui-p-0 ui-text-subtle hover:ui-bg-text/[0.08] data-[pressed]:ui-bg-text/[0.12] disabled:ui-cursor-not-allowed disabled:ui-text-text/[0.38]",
                      children: /* @__PURE__ */ i(De, { width: 24, height: 24 })
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ i(
          Ne,
          {
            "data-ui-overlay": "",
            UNSTABLE_portalContainer: N || void 0,
            "data-ui-theme": y,
            offset: 8,
            "data-slot": "date-picker-menu",
            placement: "bottom start",
            className: "ui-kit ui-z-50 ui-w-[360px] ui-max-w-[calc(100vw-1rem)] ui-max-h-[--available-height] ui-overflow-x-hidden ui-overflow-y-auto ui-rounded-2xl ui-border-0 ui-bg-muted ui-p-3 ui-text-text ui-shadow-picker ui-outline-none [--uik-calendar-menu-bleed:12px]",
            children: /* @__PURE__ */ i(Ce, { ref: P, className: "ui-outline-none", children: /* @__PURE__ */ d(ui.Provider, { value: z, children: [
              /* @__PURE__ */ i(ze.Provider, { value: {}, children: /* @__PURE__ */ i(
                Di,
                {
                  "aria-label": `Choose ${e}`,
                  value: w ? W(w) : null,
                  onChange: (T) => M(T.toString()),
                  minValue: a ? W(a) : void 0,
                  maxValue: r ? W(r) : void 0,
                  isDisabled: l,
                  isReadOnly: n,
                  autoFocus: !0,
                  className: "ui-min-h-[392px]",
                  children: /* @__PURE__ */ i(te, {})
                }
              ) }),
              /* @__PURE__ */ d("div", { className: "ui-flex ui-h-10 ui-items-center ui-justify-end ui-gap-2", children: [
                !o && !l && !n && !!(t || w) && /* @__PURE__ */ i(
                  K,
                  {
                    variant: "ghost",
                    "aria-label": `Clear ${e}`,
                    className: "ui-mr-auto !ui-min-h-9 !ui-px-3 !ui-py-1 !ui-text-primary",
                    onClick: () => {
                      M(null), u(null), g(!1);
                    },
                    children: "Clear"
                  }
                ),
                /* @__PURE__ */ i(
                  K,
                  {
                    variant: "ghost",
                    className: "!ui-min-h-9 !ui-px-3 !ui-py-1 !ui-text-primary",
                    onClick: () => g(!1),
                    children: "Cancel"
                  }
                ),
                /* @__PURE__ */ i(
                  K,
                  {
                    variant: "ghost",
                    className: "!ui-min-h-9 !ui-px-3 !ui-py-1 !ui-text-primary",
                    disabled: !w || !!(a && w < a || r && w > r),
                    onClick: () => {
                      u(w), g(!1);
                    },
                    children: "OK"
                  }
                )
              ] })
            ] }) })
          }
        )
      ] })
    }
  );
}
function Su({
  label: e,
  value: t,
  onChange: u,
  min: a,
  max: r,
  disabled: l,
  readOnly: n,
  required: o,
  description: c,
  error: m,
  className: p,
  name: s,
  hourCycle: b = 12
}) {
  const y = O();
  return /* @__PURE__ */ i(
    ke,
    {
      value: t ? zi(t) : null,
      onChange: (N) => u(N ? N.toString().slice(0, 5) : null),
      minValue: a ? zi(a) : void 0,
      maxValue: r ? zi(r) : void 0,
      isDisabled: l,
      isReadOnly: n,
      isRequired: o,
      isInvalid: !!m,
      hourCycle: b,
      granularity: "minute",
      name: s,
      className: p,
      children: /* @__PURE__ */ i(
        ti,
        {
          id: y,
          label: e,
          required: o,
          disabled: l,
          error: m,
          alwaysFloat: !0,
          renderLabel: (N) => /* @__PURE__ */ i(Ri, { ...N }),
          message: /* @__PURE__ */ i(ee, { error: m, description: c }),
          children: /* @__PURE__ */ i(
            ji,
            {
              "data-slot": "time-field-control",
              className: h(
                di,
                "ui-flex ui-h-14 ui-items-center data-[disabled]:ui-cursor-not-allowed data-[disabled]:ui-text-text/[0.38]"
              ),
              children: (N) => /* @__PURE__ */ i(Oi, { segment: N, className: ie })
            }
          )
        }
      )
    }
  );
}
function qe(e) {
  return /* @__PURE__ */ i(
    ue,
    {
      ...e,
      multiple: !1,
      onChange: (t) => e.onChange(typeof t == "string" ? t : null)
    }
  );
}
function Tu(e) {
  return /* @__PURE__ */ i(
    ue,
    {
      ...e,
      multiple: !0,
      onChange: (t) => e.onChange(Array.isArray(t) ? t : [])
    }
  );
}
function ue({
  label: e,
  options: t,
  value: u,
  onChange: a,
  description: r,
  error: l,
  className: n,
  placeholder: o,
  disabled: c,
  required: m,
  name: p,
  inputValue: s,
  onInputChange: b,
  loading: y,
  emptyMessage: N = "No options found",
  serverFiltering: z,
  disablePopupWhenEmpty: P = !1,
  allowCustomValue: v = !1,
  multiple: g
}) {
  const w = O(), M = vi(null), [C, T] = H(""), [I, S] = H(!1), J = Array.isArray(u) ? u : u === null ? [] : [u], G = !!(P && v && !t.some(
    (f) => !f.disabled && !J.includes(f.value)
  )), ai = I && !G, ri = !!((Array.isArray(u) ? u.length : u) || (s ?? C)), hi = D(), mi = R(), U = v && typeof u == "string" && !t.some((f) => f.value === u) ? [{ value: u, label: u }, ...t] : t, V = (f) => {
    var A;
    return ((A = U.find(($) => $.value === f)) == null ? void 0 : A.label) || f;
  }, X = () => {
    const f = (s ?? C).trim();
    if (G && f && J.includes(f)) {
      T(""), b == null || b("");
      return;
    }
    v && f && !U.some(
      (A) => A.label.toLocaleLowerCase() === f.toLocaleLowerCase()
    ) && (a(
      g ? [...Array.isArray(u) ? u : [], f] : f
    ), T(""), b == null || b(""), S(!1));
  };
  return /* @__PURE__ */ d(
    L.Root,
    {
      multiple: g,
      value: u,
      onValueChange: a,
      items: U.map((f) => f.value),
      itemToStringLabel: V,
      filter: z ? null : void 0,
      open: ai,
      onOpenChange: (f, A) => {
        !f && (A.reason === "outside-press" || A.reason === "focus-out") && X(), S(f);
      },
      name: p,
      disabled: c,
      required: m,
      inputValue: g ? s ?? C : s,
      onInputValueChange: (f) => {
        T(f), b == null || b(f);
      },
      children: [
        /* @__PURE__ */ i(
          ti,
          {
            id: w,
            label: e,
            description: r,
            error: l,
            className: n,
            required: m,
            disabled: c,
            select: !0,
            children: /* @__PURE__ */ d(
              L.Chips,
              {
                ref: M,
                "data-slot": "autocomplete-control",
                "data-placeholder": ri ? void 0 : "",
                "data-popup-open": ai ? "" : void 0,
                className: h(
                  di,
                  "ui-group/autocomplete ui-flex ui-min-h-14 ui-min-w-0 ui-items-center ui-gap-3 !ui-py-2",
                  c && "ui-cursor-not-allowed ui-text-text/[0.38]"
                ),
                children: [
                  /* @__PURE__ */ d("div", { className: "ui-flex ui-min-w-0 ui-flex-1 ui-flex-wrap ui-items-center ui-gap-2", children: [
                    g && Array.isArray(u) && u.map((f) => /* @__PURE__ */ d(
                      L.Chip,
                      {
                        className: h(
                          "ui-inline-flex ui-max-w-full ui-items-center ui-gap-1 ui-rounded-full ui-px-2.5 ui-py-1 ui-text-xs ui-font-medium",
                          c ? "ui-bg-text/[0.12] ui-text-text/[0.38]" : "ui-bg-primary-soft ui-text-primary"
                        ),
                        children: [
                          /* @__PURE__ */ i("span", { className: "ui-truncate", children: V(f) }),
                          /* @__PURE__ */ i(
                            L.ChipRemove,
                            {
                              "aria-label": `Remove ${V(f)}`,
                              className: "ui-ml-1 ui-shrink-0 ui-cursor-pointer ui-rounded-full ui-border-0 ui-bg-transparent ui-px-1 ui-text-inherit disabled:ui-cursor-not-allowed",
                              children: /* @__PURE__ */ i(
                                Y,
                                {
                                  width: 14,
                                  height: 14,
                                  className: "ui-pointer-events-none"
                                }
                              )
                            }
                          )
                        ]
                      },
                      f
                    )),
                    /* @__PURE__ */ i(
                      L.Input,
                      {
                        id: w,
                        "aria-labelledby": `${w}-label`,
                        placeholder: o || (g ? "Add an option…" : "Search options…"),
                        "aria-invalid": !!l || void 0,
                        "aria-describedby": r || l ? `${w}-help` : void 0,
                        onFocus: () => {
                          c || S(!0);
                        },
                        onBlur: X,
                        onKeyDown: (f) => {
                          if (G && f.key === "Enter" && !f.nativeEvent.isComposing && f.nativeEvent.keyCode !== 229) {
                            f.preventDefault(), f.stopPropagation(), f.preventBaseUIHandler(), f.repeat || X();
                            return;
                          }
                          if (f.key === "Escape" && !ai) {
                            f.preventBaseUIHandler();
                            return;
                          }
                          v && f.key === "Enter" && !f.nativeEvent.isComposing && (s ?? C).trim() && !U.some(
                            (A) => A.label.toLocaleLowerCase().includes((s ?? C).toLocaleLowerCase())
                          ) && (f.preventDefault(), X());
                        },
                        className: h(
                          "ui-w-0 ui-flex-1 ui-border-0 ui-bg-transparent ui-p-0 !ui-text-base !ui-leading-6 ui-text-text ui-caret-primary ui-outline-none focus-visible:!ui-outline-none disabled:ui-cursor-not-allowed disabled:ui-text-text/[0.38]",
                          g ? "ui-min-w-24 placeholder:ui-text-sm" : "ui-min-w-0",
                          ri ? "placeholder:ui-text-subtle" : "placeholder:ui-text-transparent group-focus-within/autocomplete:placeholder:ui-text-subtle group-data-[popup-open]/autocomplete:placeholder:ui-text-subtle"
                        )
                      }
                    )
                  ] }),
                  /* @__PURE__ */ d("div", { className: "ui-flex ui-shrink-0 ui-items-center ui-gap-3", children: [
                    G && !g && !m && u && /* @__PURE__ */ i(
                      L.Clear,
                      {
                        "aria-label": `Clear ${e}`,
                        className: "ui-flex ui-h-6 ui-w-6 ui-cursor-pointer ui-items-center ui-justify-center ui-rounded-full ui-border-0 ui-bg-transparent ui-p-0 ui-text-subtle hover:ui-bg-text/[0.08] disabled:ui-cursor-not-allowed disabled:ui-text-text/[0.38]",
                        children: /* @__PURE__ */ i(
                          Y,
                          {
                            width: 24,
                            height: 24,
                            className: "ui-pointer-events-none"
                          }
                        )
                      }
                    ),
                    !G && /* @__PURE__ */ i(
                      L.Trigger,
                      {
                        "aria-label": `Show ${e} options`,
                        className: "ui-flex ui-h-6 ui-w-6 ui-cursor-pointer ui-items-center ui-justify-center ui-rounded-full ui-border-0 ui-bg-transparent ui-p-0 ui-text-subtle hover:ui-bg-text/[0.08] disabled:ui-cursor-not-allowed disabled:ui-text-text/[0.38] motion-safe:ui-transition-transform motion-safe:ui-duration-150 data-[popup-open]:ui-rotate-180",
                        children: /* @__PURE__ */ i(
                          ci,
                          {
                            width: 24,
                            height: 24,
                            className: "ui-pointer-events-none"
                          }
                        )
                      }
                    )
                  ] })
                ]
              }
            )
          }
        ),
        !G && /* @__PURE__ */ i(L.Portal, { container: mi || void 0, children: /* @__PURE__ */ i(
          L.Positioner,
          {
            anchor: M,
            sideOffset: 6,
            align: "start",
            className: "ui-z-50",
            children: /* @__PURE__ */ d(
              L.Popup,
              {
                "data-ui-overlay": "",
                "data-ui-theme": hi,
                className: h(
                  si,
                  "ui-w-[--anchor-width] ui-max-w-[calc(100vw-1rem)] ui-overflow-hidden !ui-p-0"
                ),
                children: [
                  y && /* @__PURE__ */ d(
                    "div",
                    {
                      role: "status",
                      className: "ui-flex ui-items-center ui-gap-2 ui-p-3 ui-text-sm ui-text-subtle",
                      children: [
                        /* @__PURE__ */ i(wi, { label: "Loading options", size: 16 }),
                        "Loading options…"
                      ]
                    }
                  ),
                  /* @__PURE__ */ i(L.Empty, { className: "ui-text-sm ui-text-subtle", children: /* @__PURE__ */ i("span", { className: "ui-block ui-p-3", children: y ? "Searching…" : N }) }),
                  /* @__PURE__ */ i(L.List, { className: "ui-scrollbar ui-max-h-60 ui-overflow-x-hidden ui-overflow-y-auto ui-p-2 ui-outline-none [scrollbar-gutter:stable]", children: (f) => {
                    var A;
                    return /* @__PURE__ */ d(
                      L.Item,
                      {
                        value: f,
                        disabled: (A = U.find(($) => $.value === f)) == null ? void 0 : A.disabled,
                        className: "ui-flex ui-cursor-pointer ui-items-center ui-justify-between ui-gap-3 ui-rounded-lg ui-px-3 ui-py-2.5 ui-text-sm ui-outline-none data-[highlighted]:ui-bg-muted data-[selected]:ui-bg-primary-soft data-[selected]:ui-text-primary data-[disabled]:ui-opacity-40",
                        children: [
                          V(f),
                          /* @__PURE__ */ i(L.ItemIndicator, { children: /* @__PURE__ */ i(yi, { width: 18, height: 18 }) })
                        ]
                      },
                      f
                    );
                  } }),
                  !m && J.length > 0 && /* @__PURE__ */ i("div", { className: "ui-flex ui-justify-end ui-border-0 ui-border-t ui-border-solid ui-border-border ui-p-2", children: /* @__PURE__ */ i(
                    L.Clear,
                    {
                      "aria-label": `Clear ${e}`,
                      tabIndex: 0,
                      className: "ui-flex ui-h-8 ui-min-w-16 ui-cursor-pointer ui-items-center ui-justify-center ui-rounded-full ui-border-0 ui-bg-transparent ui-px-3 ui-text-sm ui-font-medium ui-text-primary hover:ui-bg-muted disabled:ui-cursor-not-allowed",
                      children: "Clear"
                    }
                  ) })
                ]
              }
            )
          }
        ) })
      ]
    }
  );
}
function Au({
  loadOptions: e,
  debounceMs: t = 250,
  ...u
}) {
  const [a, r] = H(""), [l, n] = H(), o = !l || l.query !== a || l.loader !== e;
  return de(() => {
    const c = new AbortController(), m = setTimeout(() => {
      e(a, c.signal).then((p) => {
        c.signal.aborted || n({ query: a, loader: e, options: p });
      }).catch(() => {
        c.signal.aborted || n({
          query: a,
          loader: e,
          options: [],
          failure: "Could not load options. Try searching again."
        });
      });
    }, t);
    return () => {
      clearTimeout(m), c.abort();
    };
  }, [a, e, t]), /* @__PURE__ */ i(
    qe,
    {
      ...u,
      options: o ? [] : l.options,
      loading: o,
      error: u.error || (o ? void 0 : l.failure),
      inputValue: a,
      onInputChange: (c) => {
        var m;
        r(c), (m = u.onInputChange) == null || m.call(u, c);
      },
      serverFiltering: !0
    }
  );
}
function Ke({
  open: e,
  onOpenChange: t,
  title: u,
  description: a,
  children: r,
  footer: l,
  className: n,
  dismissible: o = !0,
  direction: c = "bottom"
}) {
  const m = D(), p = R(), [s, b] = H(null);
  return /* @__PURE__ */ i(
    F.Root,
    {
      open: e,
      swipeDirection: c === "bottom" ? "down" : c === "top" ? "up" : c,
      disablePointerDismissal: !o,
      onOpenChange: (y, N) => {
        !y && !o ? N.cancel() : t(y);
      },
      children: /* @__PURE__ */ d(F.Portal, { container: p || void 0, children: [
        /* @__PURE__ */ i(
          F.Backdrop,
          {
            "data-slot": "drawer-backdrop",
            className: "ui-fixed ui-inset-0 ui-z-50 ui-bg-black/60 ui-opacity-[calc(1_-_var(--drawer-swipe-progress,0))] data-[starting-style]:ui-opacity-0 data-[ending-style]:ui-opacity-0 data-[swiping]:ui-transition-none motion-safe:ui-transition-opacity motion-safe:ui-duration-300"
          }
        ),
        /* @__PURE__ */ i(
          F.Viewport,
          {
            "data-base-ui-swipe-ignore": o ? void 0 : "",
            className: "ui-fixed ui-inset-0 ui-z-50",
            children: /* @__PURE__ */ i(
              F.Popup,
              {
                ref: b,
                "data-ui-overlay": "",
                "data-direction": c,
                "data-slot": "drawer-popup",
                "data-ui-theme": m,
                "aria-modal": "true",
                initialFocus: !0,
                finalFocus: !0,
                className: h(
                  "ui-kit ui-fixed ui-flex ui-flex-col ui-gap-5 ui-border ui-border-solid ui-border-border ui-bg-surface ui-p-6 ui-text-text ui-outline-none ui-translate-x-[var(--drawer-swipe-movement-x,0px)] ui-translate-y-[var(--drawer-swipe-movement-y,0px)] data-[swiping]:ui-transition-none motion-safe:ui-transition-transform motion-safe:ui-duration-[calc(300ms*var(--drawer-swipe-strength,1))] motion-safe:ui-ease-out",
                  {
                    bottom: "ui-inset-x-0 ui-bottom-0 ui-max-h-[85dvh] ui-rounded-t-3xl ui-pb-[max(1.5rem,env(safe-area-inset-bottom))] data-[starting-style]:ui-translate-y-full data-[ending-style]:ui-translate-y-full",
                    top: "ui-inset-x-0 ui-top-0 ui-max-h-[85dvh] ui-rounded-b-3xl data-[starting-style]:-ui-translate-y-full data-[ending-style]:-ui-translate-y-full",
                    left: "ui-inset-y-0 ui-left-0 ui-w-[min(90vw,28rem)] ui-rounded-r-3xl data-[starting-style]:-ui-translate-x-full data-[ending-style]:-ui-translate-x-full",
                    right: "ui-inset-y-0 ui-right-0 ui-w-[min(90vw,28rem)] ui-rounded-l-3xl data-[starting-style]:ui-translate-x-full data-[ending-style]:ui-translate-x-full"
                  }[c],
                  n
                ),
                children: /* @__PURE__ */ d(ui.Provider, { value: s, children: [
                  c === "bottom" && /* @__PURE__ */ i(
                    "div",
                    {
                      "aria-hidden": "true",
                      "data-slot": "drawer-handle",
                      className: "ui-mx-auto ui-h-1 ui-w-8 ui-shrink-0 ui-rounded-full ui-bg-border"
                    }
                  ),
                  /* @__PURE__ */ d("div", { className: "ui-flex ui-shrink-0 ui-items-start ui-justify-between ui-gap-3", children: [
                    /* @__PURE__ */ d("div", { children: [
                      /* @__PURE__ */ i(F.Title, { className: "ui-m-0 ui-text-xl ui-font-semibold", children: u }),
                      a && /* @__PURE__ */ i(F.Description, { className: "ui-mb-0 ui-mt-2 ui-text-sm ui-text-subtle", children: a })
                    ] }),
                    o && /* @__PURE__ */ i(
                      F.Close,
                      {
                        render: /* @__PURE__ */ i(Ii, { label: "Close drawer", variant: "ghost", children: /* @__PURE__ */ i(Y, {}) })
                      }
                    )
                  ] }),
                  /* @__PURE__ */ i(F.Content, { className: "ui-min-h-0 ui-overflow-y-auto", children: r }),
                  l && /* @__PURE__ */ i("div", { className: "ui-flex ui-shrink-0 ui-justify-end ui-gap-2", children: l })
                ] })
              }
            )
          }
        )
      ] })
    }
  );
}
const Lu = Ke;
function Vu({
  label: e,
  items: t,
  onAction: u,
  trigger: a,
  open: r,
  onOpenChange: l,
  anchor: n
}) {
  const o = D(), c = R(), m = O(), p = t.some((s) => !s.separator && !!s.icon);
  return /* @__PURE__ */ d(q.Root, { open: r, onOpenChange: l, children: [
    a ? /* @__PURE__ */ i(q.Trigger, { render: a }) : /* @__PURE__ */ d(q.Trigger, { render: /* @__PURE__ */ i(K, { variant: "outline" }), children: [
      e,
      /* @__PURE__ */ i(ci, {})
    ] }),
    /* @__PURE__ */ i(q.Portal, { container: c || void 0, children: /* @__PURE__ */ i(
      q.Positioner,
      {
        anchor: n || void 0,
        sideOffset: 8,
        align: "end",
        className: "ui-z-50",
        children: /* @__PURE__ */ i(
          q.Popup,
          {
            finalFocus: n ? () => n : void 0,
            "data-ui-overlay": "",
            "data-ui-theme": o,
            "aria-label": e,
            className: "ui-scrollbar ui-kit ui-w-max ui-min-w-[200px] ui-max-w-[min(17.5rem,calc(100vw-1rem))] ui-max-h-[min(var(--available-height),calc(100dvh-1rem))] ui-origin-[--transform-origin] ui-overflow-x-hidden ui-overflow-y-auto ui-rounded-lg ui-border ui-border-solid ui-border-border ui-bg-surface ui-p-1 ui-text-text ui-shadow-none ui-outline-none focus-visible:!ui-outline-none data-[starting-style]:ui-scale-[0.8] data-[starting-style]:ui-opacity-0 data-[ending-style]:ui-scale-[0.8] data-[ending-style]:ui-opacity-0 motion-safe:ui-transition-[opacity,transform] motion-safe:ui-duration-150 motion-safe:ui-ease-out",
            children: t.map(
              (s, b) => s.separator ? /* @__PURE__ */ i(
                q.Separator,
                {
                  className: "ui-mx-3 ui-my-2 ui-h-px ui-border-0 ui-bg-border"
                },
                s.id
              ) : /* @__PURE__ */ d(
                q.Item,
                {
                  render: s.render,
                  disabled: s.disabled,
                  label: s.label,
                  "aria-labelledby": `${m}-${b}-label`,
                  "aria-describedby": s.description ? `${m}-${b}-description` : void 0,
                  onClick: () => {
                    var y;
                    (y = s.onAction) == null || y.call(s), u == null || u(s.id);
                  },
                  className: h(
                    "ui-relative ui-flex ui-cursor-pointer ui-items-center ui-gap-3 ui-px-3 ui-rounded ui-py-2 ui-text-sm ui-leading-5 ui-outline-none focus-visible:!ui-outline-none focus-visible:ui-shadow-[inset_0_0_0_2px_rgb(var(--uik-primary))] before:ui-pointer-events-none before:ui-absolute before:ui-inset-0 before:ui-bg-current before:ui-opacity-0 before:ui-content-[''] data-[highlighted]:before:ui-opacity-[0.08] focus-visible:before:ui-opacity-[0.12] active:before:ui-opacity-[0.12] data-[highlighted]:focus-visible:before:ui-opacity-[0.12] data-[highlighted]:active:before:ui-opacity-[0.12] data-[disabled]:ui-cursor-default data-[disabled]:before:!ui-opacity-0 motion-safe:before:ui-transition-opacity motion-safe:before:ui-duration-100",
                    s.description ? "ui-min-h-14" : "ui-min-h-10",
                    s.disabled ? "!ui-text-text/[0.38]" : s.destructive && "ui-text-danger"
                  ),
                  children: [
                    p && /* @__PURE__ */ i(
                      "span",
                      {
                        "aria-hidden": "true",
                        className: h(
                          "ui-relative ui-flex ui-h-[18px] ui-w-[18px] ui-shrink-0 ui-items-center ui-justify-center [&>svg]:ui-h-[18px] [&>svg]:ui-w-[18px]",
                          s.disabled || s.destructive ? "ui-text-inherit" : "ui-text-subtle"
                        ),
                        children: s.icon
                      }
                    ),
                    /* @__PURE__ */ d("span", { className: "ui-relative ui-grid ui-min-w-0 ui-flex-1 ui-break-words", children: [
                      /* @__PURE__ */ i("span", { id: `${m}-${b}-label`, children: s.label }),
                      s.description && /* @__PURE__ */ i(
                        "span",
                        {
                          id: `${m}-${b}-description`,
                          className: h(
                            "ui-text-xs ui-leading-4",
                            s.disabled ? "ui-text-inherit" : "ui-text-subtle"
                          ),
                          children: s.description
                        }
                      )
                    ] })
                  ]
                },
                s.id
              )
            )
          }
        )
      }
    ) })
  ] });
}
function Hu({
  label: e,
  items: t,
  value: u,
  onChange: a
}) {
  return /* @__PURE__ */ d(
    pi.Root,
    {
      value: u,
      onValueChange: (r) => a(String(r)),
      children: [
        /* @__PURE__ */ i(
          pi.List,
          {
            activateOnFocus: !0,
            "aria-label": e,
            className: "ui-flex ui-gap-4 ui-border-0 ui-border-b ui-border-solid ui-border-border",
            children: t.map((r) => /* @__PURE__ */ i(
              pi.Tab,
              {
                value: r.value,
                disabled: r.disabled,
                className: h(
                  "ui-cursor-pointer ui-border-0 ui-border-b-2 ui-border-solid ui-bg-transparent ui-px-1 ui-py-3 ui-text-sm ui-font-medium disabled:ui-cursor-not-allowed disabled:ui-opacity-40",
                  r.value === u ? "ui-border-primary ui-text-primary" : "ui-border-transparent ui-text-subtle hover:ui-text-text"
                ),
                children: r.label
              },
              r.value
            ))
          }
        ),
        t.map((r) => /* @__PURE__ */ i(pi.Panel, { value: r.value, className: "ui-py-5", children: r.content }, r.value))
      ]
    }
  );
}
const ae = Mi(null);
function Bu({
  children: e,
  maxToasts: t = 4
}) {
  return /* @__PURE__ */ i(_.Provider, { timeout: 4e3, limit: Math.max(1, t), children: /* @__PURE__ */ i(Ye, { children: e }) });
}
function Ye({ children: e }) {
  const { add: t, close: u, toasts: a } = _.useToastManager(), r = D(), l = Hi(
    (n, o = {}) => {
      const c = `ui-kit:${n}`;
      return t({
        id: c,
        title: n,
        type: o.tone ?? "primary",
        data: { tone: o.tone ?? "primary" },
        priority: o.tone === "danger" ? "high" : "low",
        timeout: Math.max(0, o.duration ?? 4e3),
        actionProps: o.action ? {
          children: o.action.label,
          onClick: () => {
            var m;
            u(c), (m = o.action) == null || m.onClick();
          }
        } : void 0
      });
    },
    [t, u]
  );
  return /* @__PURE__ */ d(ae.Provider, { value: l, children: [
    e,
    /* @__PURE__ */ i(_.Portal, { children: /* @__PURE__ */ i(
      _.Viewport,
      {
        "data-ui-theme": r,
        className: "ui-kit ui-pointer-events-none ui-fixed ui-bottom-4 ui-right-4 ui-z-[100] ui-flex ui-w-[min(24rem,calc(100vw-2rem))] ui-flex-col-reverse ui-gap-2 ui-outline-none",
        children: a.map((n) => /* @__PURE__ */ i(Qe, { entry: n }, n.id))
      }
    ) })
  ] });
}
function Qe({ entry: e }) {
  var r;
  const t = D(), u = ((r = e.data) == null ? void 0 : r.tone) ?? "primary", a = u === "success" ? Fi : u === "danger" ? Wi : u === "warning" ? Gi : _i;
  return /* @__PURE__ */ i(
    _.Root,
    {
      toast: e,
      hidden: e.limited,
      "data-ui-theme": t,
      className: "ui-kit ui-pointer-events-auto ui-w-full ui-rounded-card ui-border ui-border-solid ui-border-border ui-bg-surface ui-p-4 ui-shadow-panel ui-outline-none [transform:translate(var(--toast-swipe-movement-x,0px),var(--toast-swipe-movement-y,0px))] data-[starting-style]:ui-opacity-0 data-[ending-style]:ui-opacity-0 motion-safe:ui-transition-[opacity,transform] motion-safe:ui-duration-150",
      children: /* @__PURE__ */ d(_.Content, { className: "ui-flex ui-items-center ui-gap-3", children: [
        /* @__PURE__ */ i(
          a,
          {
            className: {
              primary: "ui-text-primary",
              neutral: "ui-text-subtle",
              success: "ui-text-success",
              danger: "ui-text-danger",
              info: "ui-text-info",
              warning: "ui-text-warning"
            }[u]
          }
        ),
        /* @__PURE__ */ d("div", { className: "ui-min-w-0 ui-flex-1 ui-break-words ui-text-sm", children: [
          /* @__PURE__ */ i(_.Title, { render: /* @__PURE__ */ i("span", {}), className: "ui-inline" }),
          /* @__PURE__ */ i(_.Action, { className: "ui-ml-2 ui-cursor-pointer ui-border-0 ui-bg-transparent ui-font-medium ui-text-primary ui-underline" })
        ] }),
        /* @__PURE__ */ i(
          _.Close,
          {
            "aria-hidden": !1,
            render: /* @__PURE__ */ i(Ii, { label: "Dismiss notification", variant: "ghost", size: "sm", children: /* @__PURE__ */ i(Y, {}) })
          }
        )
      ] })
    }
  );
}
function Du() {
  const e = gi(ae);
  if (!e)
    throw new Error("useToast must be used within ToastProvider");
  return e;
}
function ju({
  theme: e,
  onThemeChange: t,
  className: u
}) {
  return /* @__PURE__ */ i(
    xi.Root,
    {
      nativeButton: !0,
      render: /* @__PURE__ */ i("button", { type: "button" }),
      title: "Theme Switch",
      "aria-label": "Dark theme",
      checked: e === "dark",
      onCheckedChange: (a) => t(a ? "dark" : "light"),
      className: h(
        "ui-relative ui-my-auto ui-inline-flex ui-h-[26px] ui-w-[50px] ui-shrink-0 ui-cursor-pointer ui-items-center ui-rounded-full ui-border ui-border-solid ui-border-border ui-bg-white/5 hover:ui-border-primary motion-safe:ui-transition-colors",
        u
      ),
      children: /* @__PURE__ */ i(xi.Thumb, { className: "ui-ms-0.5 ui-flex ui-h-[22px] ui-w-[22px] ui-items-center ui-justify-center ui-rounded-full ui-bg-surface ui-text-subtle motion-safe:ui-transition-transform data-[checked]:ui-translate-x-6", children: e === "dark" ? /* @__PURE__ */ i(je, { width: 18, height: 18 }) : /* @__PURE__ */ i(Oe, { width: 18, height: 18 }) })
    }
  );
}
const re = "ui-flex ui-h-full ui-w-full ui-items-center ui-justify-center ui-object-cover", Ou = j(function({ className: t, rounded: u = !0, ...a }, r) {
  return /* @__PURE__ */ i(
    "img",
    {
      "data-slot": "image",
      ...a,
      ref: r,
      className: h(re, u && "ui-rounded-card", t)
    }
  );
});
function Ru({
  processing: e = !1,
  rounded: t = !0,
  children: u,
  className: a
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      role: "status",
      "aria-label": e ? "Processing image" : "Loading image",
      className: h(
        re,
        "ui-relative ui-flex-col ui-border-2 ui-border-solid ui-border-border",
        t && "ui-rounded-card",
        e ? "motion-safe:ui-animate-image-processing" : "motion-safe:ui-animate-image-loading",
        a
      ),
      children: u
    }
  );
}
function Eu({
  color: e,
  label: t,
  selected: u = !1,
  className: a,
  style: r,
  ...l
}) {
  return /* @__PURE__ */ i(
    "button",
    {
      ...l,
      type: "button",
      "aria-label": t,
      "aria-pressed": u,
      className: h(
        "ui-inline-flex ui-h-8 ui-w-8 ui-shrink-0 ui-cursor-pointer ui-items-center ui-justify-center ui-rounded ui-border ui-border-solid ui-border-border disabled:ui-cursor-not-allowed disabled:ui-opacity-50",
        u && "ui-outline ui-outline-2 ui-outline-offset-2 ui-outline-primary",
        a
      ),
      style: { backgroundColor: e, ...r }
    }
  );
}
const Fu = j(
  function(t, u) {
    return /* @__PURE__ */ i(ne, { ...t, ref: u });
  }
), ne = j(function({
  label: t,
  value: u,
  onChange: a,
  onSearch: r,
  leadingIcon: l,
  leadingLabel: n = t,
  onLeadingClick: o,
  trailing: c,
  loading: m,
  clearable: p = !0,
  dense: s = !1,
  disabled: b,
  className: y,
  placeholder: N = "Search",
  inputComponent: z = Bi,
  fullScreenHeader: P,
  flat: v,
  leadingAction: g,
  onKeyDown: w,
  ...M
}, C) {
  const T = vi(null);
  return /* @__PURE__ */ d(
    "div",
    {
      "data-slot": "search-bar",
      "data-dense": s || void 0,
      "data-disabled": b || void 0,
      className: h(
        "ui-relative ui-isolate ui-flex ui-w-[360px] ui-max-w-full ui-min-w-0 ui-shrink-0 ui-items-center ui-gap-1 ui-border-0 ui-bg-surface-high ui-px-1 ui-text-text before:ui-pointer-events-none before:ui-absolute before:ui-inset-0 before:ui-rounded-[inherit] before:ui-bg-text before:ui-opacity-0 before:ui-content-['']",
        P ? "ui-h-[72px]" : s ? "ui-h-10" : "ui-h-14",
        v ? "ui-rounded-none" : "ui-rounded-full ui-shadow-search has-[:focus-visible]:ui-outline has-[:focus-visible]:ui-outline-[3px] has-[:focus-visible]:ui-outline-offset-2 has-[:focus-visible]:ui-outline-secondary",
        b ? "ui-opacity-40" : "hover:before:ui-opacity-[0.08] focus-within:before:ui-opacity-[0.1]",
        y
      ),
      children: [
        g ?? /* @__PURE__ */ i(
          Vi,
          {
            dense: s,
            label: n,
            disabled: b,
            onClick: () => {
              var I;
              o == null || o(), o || (I = T.current) == null || I.focus();
            },
            children: l ?? /* @__PURE__ */ i(ki, { width: s ? 20 : 24, height: s ? 20 : 24 })
          }
        ),
        /* @__PURE__ */ i(
          z,
          {
            ...M,
            ref: (I) => {
              T.current = I, typeof C == "function" ? C(I) : C && (C.current = I);
            },
            type: "search",
            value: u,
            disabled: b,
            "aria-label": t,
            placeholder: N,
            enterKeyHint: "search",
            autoComplete: M.autoComplete ?? "off",
            onChange: (I) => a(I.currentTarget.value),
            onKeyDown: (I) => {
              w == null || w(I), !I.defaultPrevented && I.key === "Enter" && !I.nativeEvent.isComposing && I.nativeEvent.keyCode !== 229 && !I.currentTarget.hasAttribute("aria-activedescendant") && (I.preventDefault(), r == null || r(u));
            },
            className: h(
              "ui-relative ui-h-full ui-w-0 ui-min-w-0 ui-flex-1 ui-border-0 ui-bg-transparent ui-p-0 ui-text-text ui-caret-primary ui-outline-none placeholder:ui-text-subtle focus-visible:!ui-outline-none disabled:ui-cursor-not-allowed [&::-webkit-search-cancel-button]:ui-hidden [&::-webkit-search-decoration]:ui-hidden",
              s ? "!ui-text-sm !ui-leading-5" : "!ui-text-base !ui-leading-6"
            )
          }
        ),
        m && /* @__PURE__ */ i(
          "span",
          {
            className: h(
              "ui-relative ui-flex ui-shrink-0 ui-items-center ui-justify-center",
              s ? "ui-h-8 ui-w-8" : "ui-h-12 ui-w-12"
            ),
            children: /* @__PURE__ */ i(
              wi,
              {
                label: `Searching ${t.toLowerCase()}`,
                size: s ? 20 : 24
              }
            )
          }
        ),
        p && u && /* @__PURE__ */ i(
          Vi,
          {
            dense: s,
            label: `Clear ${t}`,
            disabled: b,
            onClick: () => {
              var I;
              a(""), (I = T.current) == null || I.focus();
            },
            children: /* @__PURE__ */ i(Y, { width: s ? 20 : 24, height: s ? 20 : 24 })
          }
        ),
        c && /* @__PURE__ */ i(
          "div",
          {
            className: h(
              "ui-relative ui-flex ui-shrink-0 ui-items-center ui-justify-center ui-text-subtle",
              s ? "ui-min-h-8 ui-min-w-8" : "ui-min-h-12 ui-min-w-12"
            ),
            children: c
          }
        ),
        !m && !(p && u) && !c && /* @__PURE__ */ i("span", { "aria-hidden": "true", className: "ui-w-3 ui-shrink-0" })
      ]
    }
  );
});
function Vi({
  label: e,
  children: t,
  disabled: u,
  onClick: a,
  dense: r = !1
}) {
  return /* @__PURE__ */ i(
    ei,
    {
      type: "button",
      "aria-label": e,
      disabled: u,
      onClick: a,
      className: oe(r),
      children: t
    }
  );
}
function oe(e = !1) {
  return h(
    "ui-relative ui-inline-flex ui-shrink-0 ui-cursor-pointer ui-items-center ui-justify-center ui-rounded-full ui-border-0 ui-bg-transparent ui-p-0 ui-text-inherit hover:ui-bg-text/[0.08] active:ui-bg-text/[0.1] disabled:ui-cursor-not-allowed",
    e ? "ui-h-8 ui-w-8" : "ui-h-12 ui-w-12"
  );
}
function Wu({
  label: e,
  value: t,
  onChange: u,
  onSearch: a,
  placeholder: r = "Search",
  disabled: l,
  dense: n = !1,
  trailing: o,
  loading: c,
  className: m,
  name: p,
  suggestions: s,
  onSelect: b,
  children: y,
  emptyMessage: N = "No results found.",
  presentation: z = "auto",
  variant: P = "divided",
  open: v,
  onOpenChange: g
}) {
  const [w, M] = H(!1), [C, T] = H(null), I = he(
    Xe,
    Je,
    () => !1
  ), S = z === "fullscreen" || z === "auto" && I, J = v ?? w, G = D(), ai = R(), ri = vi(null), hi = O();
  function mi($) {
    l && $ || (M($), g == null || g($));
  }
  function U($) {
    a == null || a($), mi(!1);
  }
  const V = s == null ? void 0 : s.filter(
    ($) => `${$.label} ${$.description ?? ""}`.toLocaleLowerCase().includes(t.toLocaleLowerCase())
  ), X = /* @__PURE__ */ i(
    ne,
    {
      ref: ri,
      dense: n && !S,
      label: e,
      name: p,
      value: t,
      onChange: u,
      onSearch: U,
      placeholder: r,
      leadingAction: /* @__PURE__ */ i(
        B.Close,
        {
          type: "button",
          "aria-label": `Close ${e}`,
          className: oe(n && !S),
          children: /* @__PURE__ */ i(
            Be,
            {
              width: n && !S ? 20 : 24,
              height: n && !S ? 20 : 24
            }
          )
        }
      ),
      trailing: o,
      inputComponent: s ? bi.Input : void 0,
      fullScreenHeader: S && P === "divided",
      flat: P === "divided",
      className: h(
        "!ui-w-full !ui-shadow-none",
        S && P === "contained" && "ui-m-3 !ui-w-[calc(100%-24px)] ui-shrink-0"
      )
    }
  ), f = /* @__PURE__ */ i(
    "div",
    {
      "data-slot": "search-results",
      className: h(
        "ui-min-h-0 ui-flex-1 ui-overflow-y-auto ui-py-2 ui-text-text",
        P === "contained" && "ui-rounded-xl ui-bg-surface-high"
      ),
      children: c ? /* @__PURE__ */ d(
        "div",
        {
          role: "status",
          className: "ui-flex ui-items-center ui-gap-3 ui-p-4 ui-text-sm ui-text-subtle",
          children: [
            /* @__PURE__ */ i(wi, { label: "Searching", size: 24 }),
            "Searching…"
          ]
        }
      ) : s ? /* @__PURE__ */ d(ii, { children: [
        (V == null ? void 0 : V.length) === 0 && /* @__PURE__ */ i(
          "p",
          {
            role: "status",
            className: "ui-m-0 ui-p-4 ui-text-sm ui-text-subtle",
            children: N
          }
        ),
        /* @__PURE__ */ i(
          bi.List,
          {
            "aria-label": `${e} suggestions`,
            className: "ui-m-0 ui-list-none ui-p-0 ui-outline-none",
            children: ($) => {
              const E = V == null ? void 0 : V.find((le) => le.id === $);
              return E ? /* @__PURE__ */ d(
                bi.Item,
                {
                  value: $,
                  disabled: E.disabled,
                  onClick: () => {
                    u(E.label), b == null || b(E), U(E.label);
                  },
                  className: "ui-flex ui-min-h-14 ui-cursor-pointer ui-items-center ui-gap-4 ui-px-4 ui-py-3 ui-text-base ui-outline-none data-[highlighted]:ui-bg-text/[0.08] data-[disabled]:ui-cursor-default data-[disabled]:ui-opacity-40",
                  children: [
                    /* @__PURE__ */ i(
                      "span",
                      {
                        "aria-hidden": "true",
                        className: "ui-flex ui-h-6 ui-w-6 ui-shrink-0 ui-items-center ui-justify-center ui-text-subtle",
                        children: E.icon ?? /* @__PURE__ */ i(ki, { width: 24, height: 24 })
                      }
                    ),
                    /* @__PURE__ */ d("span", { className: "ui-grid ui-min-w-0 ui-gap-0.5", children: [
                      /* @__PURE__ */ i("span", { children: E.label }),
                      E.description && /* @__PURE__ */ i("span", { className: "ui-text-sm ui-text-subtle", children: E.description })
                    ] })
                  ]
                },
                $
              ) : null;
            }
          }
        )
      ] }) : y ?? /* @__PURE__ */ i("p", { className: "ui-m-0 ui-p-4 ui-text-sm ui-text-subtle", children: "Enter a search query." })
    }
  ), A = /* @__PURE__ */ d(ii, { children: [
    /* @__PURE__ */ i(B.Title, { id: hi, className: "ui-sr-only", children: e }),
    X,
    P === "divided" && /* @__PURE__ */ i("div", { "aria-hidden": "true", className: "ui-h-px ui-shrink-0 ui-bg-border" }),
    f
  ] });
  return /* @__PURE__ */ d(B.Root, { open: J, onOpenChange: mi, modal: S, children: [
    /* @__PURE__ */ d(
      B.Trigger,
      {
        disabled: l,
        "aria-label": e,
        render: /* @__PURE__ */ i("button", { type: "button" }),
        className: h(
          "ui-relative ui-isolate ui-flex ui-w-[360px] ui-max-w-full ui-min-w-0 ui-cursor-text ui-items-center ui-rounded-full ui-border-0 ui-bg-surface-high ui-text-left ui-text-text ui-shadow-search before:ui-pointer-events-none before:ui-absolute before:ui-inset-0 before:ui-rounded-[inherit] before:ui-bg-text before:ui-opacity-0 before:ui-content-[''] enabled:hover:before:ui-opacity-[0.08] enabled:active:before:ui-opacity-[0.1] disabled:ui-cursor-not-allowed disabled:ui-opacity-40",
          n ? "ui-h-10 ui-gap-3 ui-px-3 ui-text-sm" : "ui-h-14 ui-gap-4 ui-px-4 ui-text-base",
          m
        ),
        children: [
          /* @__PURE__ */ i(
            ki,
            {
              width: n ? 20 : 24,
              height: n ? 20 : 24,
              className: "ui-shrink-0"
            }
          ),
          /* @__PURE__ */ i(
            "span",
            {
              className: h(
                "ui-min-w-0 ui-flex-1 ui-truncate",
                !t && "ui-text-subtle"
              ),
              children: t || r
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ i(B.Portal, { container: ai ?? void 0, children: /* @__PURE__ */ i(
      B.Positioner,
      {
        sideOffset: n ? -40 : -56,
        align: "start",
        className: h(
          "ui-z-[60]",
          S && "!ui-fixed !ui-inset-0 !ui-h-dvh !ui-w-full !ui-transform-none"
        ),
        children: /* @__PURE__ */ i(
          B.Popup,
          {
            ref: T,
            "aria-labelledby": hi,
            initialFocus: ri,
            "data-ui-overlay": "",
            "data-ui-theme": G,
            "data-presentation": S ? "fullscreen" : "docked",
            "data-variant": P,
            className: h(
              "ui-kit ui-flex ui-min-w-0 ui-flex-col ui-outline-none focus-visible:!ui-outline-none data-[starting-style]:ui-opacity-0 data-[ending-style]:ui-opacity-0 motion-safe:ui-transition-opacity motion-safe:ui-duration-150",
              S ? "ui-h-full ui-w-full ui-max-h-dvh ui-rounded-none ui-pt-[env(safe-area-inset-top)] ui-pb-[env(safe-area-inset-bottom)]" : "ui-w-[var(--anchor-width)] ui-max-w-[calc(100vw-2rem)] ui-min-h-[min(240px,var(--available-height,240px))] ui-rounded-[28px] ui-shadow-search",
              !S && (P === "contained" ? "ui-max-h-[min(50dvh,var(--available-height,50dvh))]" : "ui-max-h-[min(66.667dvh,var(--available-height,66.667dvh))]"),
              P === "divided" ? "ui-overflow-hidden ui-bg-surface-high" : S ? "ui-bg-surface-low" : "ui-gap-0.5 ui-bg-transparent"
            ),
            children: /* @__PURE__ */ i(ui.Provider, { value: C, children: s ? /* @__PURE__ */ i(
              bi.Root,
              {
                items: V == null ? void 0 : V.map(($) => $.id),
                value: t,
                mode: "none",
                inline: !0,
                open: J,
                children: A
              }
            ) : A })
          }
        )
      }
    ) })
  ] });
}
function Je() {
  return window.matchMedia("(max-width: 599px)").matches;
}
function Xe(e) {
  const t = window.matchMedia("(max-width: 599px)");
  return t.addEventListener("change", e), () => t.removeEventListener("change", e);
}
export {
  mu as Accordion,
  It as AccountCircleIcon,
  $t as AddCircleIcon,
  Pt as AddIcon,
  cu as Alert,
  St as AppleIcon,
  Be as ArrowBackIcon,
  Tt as ArrowForwardIcon,
  At as ArrowUpwardIcon,
  Lt as ArticleIcon,
  Au as AsyncAutocomplete,
  qe as Autocomplete,
  su as Avatar,
  _e as Badge,
  Vt as BubbleChartIcon,
  K as Button,
  ru as ButtonAlt,
  Ue as Calendar,
  De as CalendarMonthIcon,
  ou as Card,
  Ht as ChatBubbleOutlineRoundedIcon,
  Fi as CheckCircleOutlineIcon,
  yi as CheckIcon,
  fu as Checkbox,
  Ti as ChevronLeftIcon,
  Ai as ChevronRightIcon,
  lu as Chip,
  Bt as CircleIcon,
  wi as CircularProgress,
  Y as CloseIcon,
  Eu as ColorSwatch,
  ku as ConfirmationDialog,
  je as DarkModeIcon,
  $u as DatePicker,
  Dt as DeleteOutlineIcon,
  Ge as Dialog,
  Ke as Drawer,
  jt as EditOutlinedIcon,
  Wi as ErrorOutlineIcon,
  Ki as FieldMessage,
  Ot as GradeIcon,
  Ii as IconButton,
  Ou as Image,
  Ru as ImagePlaceholder,
  _i as InfoOutlinedIcon,
  ci as KeyboardArrowDownIcon,
  Rt as KeyboardArrowUpIcon,
  Oe as LightModeIcon,
  Vu as Menu,
  Et as MicIcon,
  zu as Modal,
  Ft as MoreVertIcon,
  Tu as MultiAutocomplete,
  yu as MultiSelect,
  ti as OutlinedField,
  ui as OverlayContainerContext,
  Wt as PaletteIcon,
  _t as PauseIcon,
  Gt as PersonOutlineIcon,
  Ut as PictureAsPdfIcon,
  qt as PlayArrowIcon,
  Mu as Popover,
  du as Progress,
  gu as RadioGroup,
  Cu as RangeSlider,
  Yt as RemoveCircleIcon,
  Kt as RemoveIcon,
  Qt as ReportIcon,
  Jt as Rotate90DegreesCwIcon,
  Wu as Search,
  Fu as SearchBar,
  ki as SearchIcon,
  vu as Select,
  hu as Separator,
  Xt as SettingsIcon,
  Zt as ShareOutlinedIcon,
  Nu as Slider,
  Pu as StaticDatePicker,
  Lu as SwipeableDrawer,
  xu as Switch,
  Hu as Tabs,
  bu as TextArea,
  pu as TextField,
  au as ThemeProvider,
  ju as ThemeToggle,
  Su as TimePicker,
  Bu as ToastProvider,
  wu as ToggleButtonGroup,
  Iu as Tooltip,
  iu as TuneIcon,
  nu as Typography,
  eu as VisibilityIcon,
  tu as VisibilityOffIcon,
  Gi as WarningAmberOutlinedIcon,
  uu as WarningIcon,
  di as outlinedControlClass,
  R as useOverlayContainer,
  D as useTheme,
  Du as useToast
};
//# sourceMappingURL=index.js.map
